import messagesForBuilder from "../../utils/messagesForBuilder";

const selectAll = 'Select all that apply';
const amount = 'Amount:';
const amountOther = 'Other Amount:';
const bankOther = 'Other Bank:';
const howMuch = 'How much:';
const whenYouNeed = 'When:';
const accessType = 'Access:';
const borrow = 'Borrow?';
const saved = 'Saved:';
const currentAccount_amount = 'With S<span id="ampersand">&</span>T ($):';
const currentAccount_otherBankAmount = 'At another Financial Institution ($):';
const currentAccount_otherBankName = 'Other bank name:';
const currentAccount_willingToMove = 'Amount willing to move (%):';
const currentAccount_willingToMoveDollars = 'Amount moving ($):';
const amountToBorrow = 'How much do you need?';
const loanTiming = 'How soon do you need the funds?';
const loanTimingOptions = {
  now: 'Immediate',
  three: '3 months',
  six: '6+ months',
  twelve: '1 year',
  more: 'Over a Year',
};
const loanAccess = 'How will you access the funds?';
const wantsToBorrow = 'Do you wish to borrow?';
const wantsToRefinance = 'Would you like to purchase or refinance?';
const amountSaved = 'How much have you saved so far?';
const upFront = 'All at once';
const overTime = 'Over time';
const moving = 'Moving:';
const yes = 'Yes';
const no = 'No';
const yes_icon = 'fa fa-check-circle-o';
const no_icon = 'fa fa-times-circle-o';
const easy_icon = 'fa fa-check-circle-o';
const select_icon = 'fa fa-times-circle-o';

export default {
  /**
   * ============================
   * GENERAL MESSAGES
   * ============================
   */

  'answers.title': 'Review Your Answers',
  'answers.subtext': 'You can review the questions and answers from your survey below. If you need to edit your answers, {returnLink}. ' +
    'You can also click on question titles below to jump back to the specific page and change your answer.',
  'answers.subtext.previousPage': 'click here to return to the guide',

  'assistant.back': 'Back',
  'assistant.next': 'Show More',
  'assistant.skip': 'Got It!',
  'assistant.close': 'Close',

  'disclosures.subtext': 'The Merlin™ tool is provided by S<span id="ampersand">&</span>T Bank to help you find the products and services that best fit your financial needs based on your answers to questions regarding your banking preferences and goals. The recommendations provided are based on our extensive financial product knowledge. Credit products are subject to credit approval. You may wish to consult a financial advisor regarding their applicability to your unique financial goals and circumstances. Contact a branch or our Solutions Center for additional details.',

  'back': 'Back',

  'cart': 'Apply for Products',
  'cart.add': 'Add to cart',
  'cart.remove': 'Remove',
  'cart.cancel': 'Cancel',
  'cart.modal.title': 'Take action on your selected products below.',
  'cart.apply': 'Apply Now',
  'cart.apply.btn': 'Apply',
  'cart.apply.url': 'https://b043306855.account-open.online-banking-services.com/openaccount/?externalProductIds=',
  'cart.contact': 'Contact Banker',
  'cart.contact.btn': 'Contact',
  'cart.contact.url': '#!',
  'cart.credit': 'Credit Cards',
  'cart.credit.btn': 'Apply for Credit',
  'cart.credit.url': 'https://creditcardlearnmore.com/11t3/index?ecdma-lc=24710&ecid=OTHE_25940',
  'cart.loan': 'Loans',
  'cart.loan.btn': 'Apply for Loan',
  'cart.loan.url': 'https://applynow.stbank.com/apply.aspx?enc=Kw21Wblm1yxpjJabdoZaDzcOT4yUOICUgNmmTAqZ24cmTY9CYK4wo53LTGVncswF',
  'cart.mortgage': 'Mortgage',
  'cart.mortgage.btn': 'Apply for Mortgage',
  'cart.mortgage.url': 'https://stbank.mortgagewebcenter.com/Account/Login',
  'cartApplyClicked.info.title': 'Thanks For Applying',
  'cartApplyClicked.info.message': 'You should have been re-directed to the appropriate page to apply for your products or ' +
    'to contact a banker. You can also click the "Apply For Products" button again to take action on more products.',
  'cartEmpty.error.title': 'No products selected',
  'cartEmpty.error.message': 'You must add products to your cart before applying',

  'contactMe.submit': 'Continue',
  'contactForm.message': 'Please enter your contact information below, then click "Continue" to open your products via ' +
    'the online application, or a banker will contact you.',
  'contactForm.success.title': 'Thank You',
  'contactForm.success.message': 'Your information was successfully submitted!  You should have been re-directed to apply' +
    ' for your banking selections, or a banker will be reaching out to you using the information provided.  You can also ' +
    ' click "Apply for Products" again if you’d like to choose additional products.',

  'editAnswer': 'Edit Answer',

  'error.title': 'Error',
  'error.question.required': 'This question requires an answer',
  'error.question.between': 'Value must be between {0} and {1}',
  'error.question.zipCode': 'Please enter a valid zip code',
  'error.question.postalCode': 'Please enter a valid zip code',
  'error.questionGroup.required': 'You must answer a question',
  'error.questionGroup.between': 'Total value must be between {0} and {1}',
  'error.questionGroup.equal': 'Total value must equal to {0}',

  'footer.phoneNumber': '800.325.2265',
  'footer.copyright': 'Copyright {year} S<span id="ampersand">&</span>T Bank. All Rights Reserved',

  'guide.name': 'S<span id="ampersand">&</span>T Bank',

  'landing.title': "Let's Find the Perfect Account for You.",
  'landing.subtitle': 'Meet Merlin',
  'landing.message': "It will be so easy, It's going to feel like magic.",
  'landing.readyToStart': "Let's Go",
  'landing.assistant.getStarted.title': 'Meet Merlin',
  'landing.assistant.welcome.content': "Hello!! I am Merlin™, your online financial guide. I’m so excited that you picked me to help you " +
    "with your path to financial well-being. I will guide you through answering a few questions so that I can understand your financial " +
    "circumstances. Getting to know you better will allow me to provide you the best possible financial solutions to support your goals. " +
    "If you're ready to get started, click the <b>Let's Go</b> button.",
  'landing.assistant.getStarted.button': 'Get Started',

  'merlinIconText': 'Need more info here? Click Merlin for helpful tips!',

  'nav.prev': 'Back',
  'nav.next': 'Next',
  'next': 'Next',

  pleaseSelect: 'Please Select',

  'product.seeDetails': 'See Details',
  'product.seeDetails.header': 'Product Details',
  'product.noDescription': 'Visit the S<span id="ampersand">&</span>T Bank website or contact a banker to learn more about this product',
  'product.features.title': 'Why this product is right for you:',
  'product.services.title': 'Additional services with this product:',
  'product.disclosures': 'Disclosures',
  'productGroup.consumer-checking': 'Checking Products',
  'productGroup.consumer-checking-minors': 'Checking Products for Youth',
  'productGroup.consumer-money': 'Money Market Products',
  'productGroup.consumer-savings': 'Savings Products',
  'productGroup.consumer-cd': 'Certificate of Deposit Products',
  'productGroup.consumer-holiday': 'Holiday Products',
  'productGroup.consumer-mortgage': 'Mortgage Products',
  'productGroup.consumer-loans': 'Loan Products',
  'productGroup.consumer-credit': 'Credit Card Products',
  'productGroup.consumer-checking.icon': '/classpath/assets/images/checking-new-rc.svg',
  'productGroup.consumer-checking-minors.icon': '/classpath/assets/images/checking-new-rc.svg',
  'productGroup.consumer-money.icon': '/classpath/assets/images/checking-new-rc.svg',
  'productGroup.consumer-savings.icon': '/classpath/assets/images/savings-new-rc.svg',
  'productGroup.consumer-cd.icon': '/classpath/assets/images/cd-new-rc.svg',
  'productGroup.consumer-holiday.icon': '/classpath/assets/images/bridge-loan-new-rc.svg',
  'productGroup.consumer-mortgage.icon': '/classpath/assets/images/purchase-a-home-new-rc.svg',

  'productGroup.consumer-loans.icon': '/classpath/assets/images/money-bag-new-rc.svg',
  'productGroup.consumer-credit.icon': '/classpath/assets/images/credit-cards-new-rc.svg',

  'shareViaEmail.title': 'Send Results via Email',
  'shareViaEmail.label': 'Enter an email address below and click send:',
  'shareViaEmail.button': 'Send Email',
  'shareViaEmail.placeholder': 'user@email.com',
  'shareViaEmail.submitted.success.title': 'Email Sent',
  'shareViaEmail.submitted.success.message': 'Your results have been sent to the email address you provided.',

  'shareViaSms.title': 'Send Results via Text Message',
  'shareViaSms.label': 'Enter a phone number below and click send:',
  'shareViaSms.button': 'Send Text Message',
  'shareViaSms.placeholder': '(800) 555-1234',
  'shareViaSms.submitted.success.title': 'Text Message Sent',
  'shareViaSms.submitted.success.message': 'A text message has been sent to the phone number you provided.',

  'share.email.subject': 'S<span id="ampersand">&</span>T Bank’s Recommendations from Merlin<sup>TM</sup>',
  'share.sms.greeting': 'S<span id="ampersand">&</span>T Bank’s Recommendations from Merlin<sup>TM</sup>',

  'sidebar.entry.text': 'Welcome to S<span id="ampersand">&</span>T, help us get to know you',
  'sidebar.goals.text': 'Understanding your financial goals to personalize the best solutions for you',
  'sidebar.banking.text': 'Understanding your current finances to meet your goals',
  'sidebar.personal.text': "Let's discuss your banking preferences",
  'sidebar.residency.text': 'Help us understand your living situation',
  'sidebar.credit.text': "Let's discuss credit options",
  'sidebar.exit.text': "Almost done, just a bit more information to personalize your solutions",

  'summary.addAllProducts': 'Add All Products',
  'summary.back': 'Edit Answers',
  'summary.headerMenu.email': 'Send Email',
  'summary.headerMenu.sms': 'Text',
  'summary.headerMenu.print': 'Print',
  'summary.headerMenu.cart': 'Cart',
  'summary.subtitle': 'Congratulations, we were able to find your matching products.',
  'summary.title': 'Product Recommendations',
  'summary.subtext': 'Your product recommendations are below. Review the suggestions below and apply for the products you ' +
    'want to by adding them to the cart and following the checkout process.',
  'summary.assistant.intro-step.title': 'Congratulations!',
  'summary.assistant.intro-step.content': "I have been working very diligently behind the scenes to determine the " +
    "best S<span class='fira'>&</span>T Bank product recommendations for your financial goals. Please take a moment to review the suite of products below. <br />" +
    "Click “Add to Cart” to proceed with the application process! You will also be able to speak with one of our helpful " +
    "solution center representatives in the next steps.",
  'summary.assistant.howTo-step.title': 'How To Apply',
  'summary.assistant.howTo-step.content': 'Click "Add to Cart" on your recommended products to proceed with the application ' +
    'process!',
  'summary.assistant.apply-step.title': 'How To Apply',
  'summary.assistant.apply-step.content': 'When ready to apply, just click the "Apply For Products" button. This will open your ' +
    'cart and allow you to take action on the products you want. You will also be able to speak with one of our helpful solution ' +
    'center representatives during the final steps.',
  'summary.assistant.social-step.title': 'Save Your Results',
  'summary.assistant.social-step.content': 'Don’t forget to email or text your results! You will receive a link back to this page ' +
    'and can apply at any time or reach out to one of my friends at the S<span id="ampersand">&</span>T Bank solution center. They are always happy to help! ' +
    'Just mention that you completed a guide with Merlin and make sure you have this page handy.',

  /**
   * ============================
   * MERLIN SURVEY PAGE MESSAGES
   * ============================
   */
  'isCustomer.merlin.tooltip': "Hi, I'm Merlin and welcome to your first question page! I'll be here in the top right corner " +
    "if you need my helpful tips or look for a green blinking dot! Click the 'Show More' button here if you would like a " +
    "quick review how this page works.",
  'isCustomer.merlin.tooltip.btnText': 'Show More',
  'isCustomer.merlin.demo-1.content': "Welcome to your first question. Let's do a quick review how this page works.",
  'isCustomer.merlin.demo-2.title': 'Question Area',
  'isCustomer.merlin.demo-2.content': 'This is the question area where you will enter your answers for each page. Your answers ' +
    'will better help me find the best accounts for you!',
  'isCustomer.merlin.demo-3.title': 'Track Your Progress',
  'isCustomer.merlin.demo-3.content': 'Every time you finish completing a question page your progress will be updated. ' +
    'Check here to stay updated with your progression.',
  'isCustomer.merlin.demo-4.title': 'Navigation',
  'isCustomer.merlin.demo-4.content': 'Once you are ready to go to the next question page (or if you would like to go back to ' +
    'a previous question), just click one of these buttons to do so!',
  'isCustomer.merlin.demo-5.content': "That wraps it up for our overview. I’ll be assisting you throughout the process today. " +
    "As you go through the series of questions, I'll display a clickable <b class='green-text'>Green Dot</b> (as seen below) if " +
    "I have special tips for the page. You can also click on my icon at any point throughout the process for some extra " +
    "information. <span class='beacon'></span>",

  'reasonForVisit.merlin.tooltip': 'These helpful facts below boost my intelligence! By providing me with one or more selections, ' +
    'I will be able to understand more information about what brought you to S<span id="ampersand">&</span>T Bank. ',

  'goals.merlin.tooltip': 'I would love to help you reach your financial goals but will need some more information from you. ' +
    'Please select “Add New Goal” so I can determine other products that will help you reach any short term or future financial goals you may be thinking about.',
  'goals.merlin.demo-1.title': 'How to use the Builder',
  'goals.merlin.demo-1.content': 'This is a Builder page. You will use this page to add options related to your financial goals.',
  'goals.merlin.demo-2.title': 'Adding an Option',
  'goals.merlin.demo-2.content': 'To add an option, just click the "Enter Goal" button. This will prompt a modal to show up, where ' +
    'you will answer a few questions about your goal.',
  'goals.merlin.demo-3.content': 'Once you finish answer questions about your goal, just click the save button in the modal. The ' +
    'options that you add will show in this area.',

  'currentAccounts.merlin.tooltip': "Did you know that you can easily move your balances from another financial institution to S<span class='fira'>&</span>T Bank? Great news! " +
    "We have an easy way to do that using ClickSwitch. Stop by your local branch or call our solution center at 800.325.2265 for help making the switch today! <br /><br />" +
    "In the meantime, please tell me the least amount you currently keep in your account on a monthly basis and if you’re interested in transferring to S<span class='fira'>&</span>T Bank.",
  'currentAccounts.merlin.demo-1.content': 'This is another Builder page, it works just like the goals builder page. However, you ' +
    'will add items related to your current accounts on this page to help us get a better picture of how we can meet your goals.',

  'checking-account.merlin.tooltip': "I'm interested in understanding your average amount of checking account activity below. " +
    'Since your spending habits vary each month, please indicate your best estimate.',

  'savings-account.merlin.tooltip': "I'm interested in understanding your average amount of savings account activity below. "+
    'Since your spending habits vary each month, please indicate your best estimate.',

  'cdPreference.merlin.tooltip': 'Please select one of the options below to better understand your CD preferences.',

  'statements.merlin.tooltip': 'Please select one of the options below to better understand your statement preferences.',

  'interest.merlin.tooltip': 'Earning interest can be very beneficial to your checking account. Is this important to you?',

  'checking-preference.merlin.tooltip': 'Please select one of the options below to better understand your checking preferences.',

  'residency.merlin.tooltip': 'Please select one of the options below to better understand your current living style.',

  'home-value.merlin.tooltip': 'Based off my intelligent calculations, I will display your estimated home equity amount after ' +
    'completing these questions. Did you know you can borrow from your home equity to reach many of your goals sooner?',
  'home-value.merlin.equity-helper.content': 'This field will update automatically as you answer the questions above to determine ' +
    'the equity available in your home.',

  'homeEquity.merlin.tooltip': 'Please select an option below to indicate which goal type you would like to use your home equity towards. <br /><br />' +
    'If you would not like to use your home equity, please select “No, thank you” and click the “Next” button.',

  'creditCard.merlin.tooltip': 'S<span id="ampersand">&</span>T Bank offers many credit card options to best suit your spending style.',

  'creditCardUsage.merlin.tooltip': 'Choose how you would use your credit card here. ',

  'creditCardFeatures.merlin.tooltip': 'It is a challenge to pick only one option here! Which is first on your list?',

  'creditCardTravel.merlin.tooltip': 'There are fantastic credit card perks S<span id="ampersand">&</span>T Bank offers. Having TSA Pre-check or Global Entry for no cost is ideal! Bon Voyage!',

  'homeOwnerStatus.merlin.tooltip': 'S<span id="ampersand">&</span>T Bank offers special accounts for those customers interested in buying their first home, Veterans or those in active duty.',

  'ageBasedBenefits.merlin.tooltip': 'Starting to save at an early age will help educate children about managing their money.',

  'demographics.merlin.tooltip': 'Please remember that you must be at least 18 years or older to apply for an account online without guardian at S<span id="ampersand">&</span>T Bank.',

  /**
   * ============================
   * QUESTION MESSAGES
   * ============================
   */
  isCustomer: 'Do you currently have any accounts at S<span id="ampersand">&</span>T Bank?',
  'isCustomer.true': 'Yes',
  'isCustomer.false': 'No',

  reasonForVisit: 'How can Merlin help you today?',
  'reasonForVisit.subtext': selectAll,
  'reasonForVisit.accounts': 'Checking',
  'reasonForVisit.investments': 'Savings',
  'reasonForVisit.goals': 'Borrow Money',
  'reasonForVisit.creditCard': 'Credit Card',
  'reasonForVisit.all': 'All of the above',

  goalsQuestionGroup: "What are your goals today?",
  'goalsQuestionGroup.subtext': 'Enter your goals below:',
  'goalTypes.cardBuilder.removeCard': '<i class="fa fa-times-circle-o"></i>',
  'goalTypes.cardBuilder.editCard': '<i class="fa fa-pencil-square-o"></i>',
  'goalTypes.cardBuilder.addCard': 'Enter Goal',
  'goalTypes.cardBuilder.modal.title': 'Select a goal from the options below.',
  goalTypes: 'Your Goals:',

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'homeGoal',
    svg: 'purchase-a-home-new-rc',
    title: 'Purchase / Refinance Home',
    cardLabel: 'Purchase / Refinance Home'
  }),
  homeGoalAmount: amountToBorrow,
  'homeGoalAmount.tooltip': "( i.e. Purchase price – down payment = borrow amount )",
  'homeGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.homeGoalAmount': `Goals: Home | ${amountToBorrow}`,
  homeGoalTiming: loanTiming,
  'homeGoalTiming.0': loanTimingOptions.now,
  'homeGoalTiming.3': loanTimingOptions.three,
  'homeGoalTiming.6': loanTimingOptions.six,
  'homeGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.homeGoalTiming': `Goals: Home | ${loanTiming}`,
  homeGoalPropertyType: 'Great! What type of home?',
  'homeGoalPropertyType.primary': 'Primary',
  'homeGoalPropertyType.secondary': 'Secondary',
  'homeGoalPropertyType.investment': 'Investment',
  'homeGoalWantsToBorrow': 'Do you wish to borrow?',
  'homeGoalWantsToBorrow.true': yes,
  'homeGoalWantsToBorrow.false': no,
  'details.homeGoalWantsToBorrow': `Goals: Home | ${ wantsToBorrow }`,
  'homeGoalWantsToRefinance': wantsToRefinance,
  'homeGoalWantsToRefinance.purchase': 'Purchase Home',
  'homeGoalWantsToRefinance.refinance': 'Refinance Home',
  'details.homeGoalWantsToRefinance': `Goals: Home | ${ wantsToRefinance }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'refinanceHomeGoal',
    svg: 'purchase-a-home-new-rc',
    title: 'Refinance a Home',
    cardLabel: 'Refinance a Home'
  }),
  refinanceHomeGoalAmount: amountToBorrow,
  'refinanceHomeGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.refinanceHomeGoalAmount': `Goals: Home | ${amountToBorrow}`,
  refinanceHomeGoalTiming: loanTiming,
  'refinanceHomeGoalTiming.0': loanTimingOptions.now,
  'refinanceHomeGoalTiming.3': loanTimingOptions.three,
  'refinanceHomeGoalTiming.6': loanTimingOptions.six,
  'refinanceHomeGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.refinanceHomeGoalTiming': `Goals: Refinance Home | ${loanTiming}`,
  refinanceHomeGoalType: 'Great! What type of home?',
  'refinanceHomeGoalType.primary': 'Primary',
  'refinanceHomeGoalType.secondary': 'Secondary',
  'refinanceHomeGoalType.investment': 'Investment',
  'refinanceHomeGoalType.cardBuilder.answerLabel': 'Type',

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'homeImprovementGoal',
    svg: 'home-improvements-new-rc',
    title: 'Home Improvements',
    cardLabel: 'Home Improvements'
  }),
  homeImprovementGoalAmount: amountToBorrow,
  'homeImprovementGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.homeImprovementGoalAmount': `Goals: Home Improvement | ${amountToBorrow}`,
  homeImprovementGoalTiming: loanTiming,
  'homeImprovementGoalTiming.0': loanTimingOptions.now,
  'homeImprovementGoalTiming.3': loanTimingOptions.three,
  'homeImprovementGoalTiming.6': loanTimingOptions.six,
  'homeImprovementGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.homeImprovementGoalTiming': `Goals: Home Improvement | ${loanTiming}`,
  homeImprovementGoalAccess: loanAccess,
  'homeImprovementGoalAccess.upFront': upFront,
  'homeImprovementGoalAccess.overTime': overTime,
  'homeImprovementGoalAccess.cardBuilder.answerLabel': accessType,
  'details.homeImprovementGoalAccess': `Goals: Home Improvement | ${loanAccess}`,
  'homeImprovementGoalWantsToBorrow': 'Do you wish to borrow?',
  'homeImprovementGoalWantsToBorrow.true': yes,
  'homeImprovementGoalWantsToBorrow.false': no,
  'details.homeImprovementGoalWantsToBorrow': `Goals: Home Improvement | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'vehicleGoal',
    svg: 'car-new-rc',
    title: 'Purchase / Refinance Vehicle',
    cardLabel: 'Purchase / Refinance Vehicle'
  }),
  vehicleGoalAmount: amountToBorrow,
  'vehicleGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.vehicleGoalAmount': `Goals: Vehicle | ${amountToBorrow}`,
  vehicleGoalTiming: loanTiming,
  'vehicleGoalTiming.0': loanTimingOptions.now,
  'vehicleGoalTiming.3': loanTimingOptions.three,
  'vehicleGoalTiming.6': loanTimingOptions.six,
  'vehicleGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.vehicleGoalTiming': `Goals: Vehicle | ${loanTiming}`,
  vehicleGoalType: 'Great! What type of vehicle?',
  'vehicleGoalType.auto': 'Auto',
  'vehicleGoalType.rv': 'RV (Recreational Vehicle)',
  'vehicleGoalType.motorcycle': 'Motorcycle',
  'vehicleGoalType.cardBuilder.answerLabel': 'Type',
  'vehicleGoalWantsToBorrow': 'Do you wish to borrow?',
  'vehicleGoalWantsToBorrow.true': yes,
  'vehicleGoalWantsToBorrow.false': no,
  'details.vehicleGoalWantsToBorrow': `Goals: Auto | ${ wantsToBorrow }`,
  'vehicleGoalWantsToRefinance': wantsToRefinance,
  'vehicleGoalWantsToRefinance.purchase': 'Purchase Vehicle',
  'vehicleGoalWantsToRefinance.refinance': 'Refinance Vehicle',
  'details.vehicleGoalWantsToRefinance': `Goals: Auto | ${ wantsToRefinance }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'refinanceVehicleGoal',
    svg: 'car-new-rc',
    title: 'Refinance a Vehicle',
    cardLabel: 'Refinance a Vehicle'
  }),
  refinanceVehicleGoalAmount: amountToBorrow,
  'refinanceVehicleGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.refinanceVehicleGoalAmount': `Goals: Refinance Vehicle | ${amountToBorrow}`,
  refinanceVehicleGoalTiming: loanTiming,
  'refinanceVehicleGoalTiming.0': loanTimingOptions.now,
  'refinanceVehicleGoalTiming.3': loanTimingOptions.three,
  'refinanceVehicleGoalTiming.6': loanTimingOptions.six,
  'refinanceVehicleGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.refinanceVehicleGoalTiming': `Goals: Refinance Vehicle | ${loanTiming}`,
  refinanceVehicleGoalType: 'Great! What type of vehicle?',
  'refinanceVehicleGoalType.auto': 'Auto',
  'refinanceVehicleGoalType.rv': 'RV (Recreational Vehicle)',
  'refinanceVehicleGoalType.motorcycle': 'Motorcycle',
  'refinanceVehicleGoalType.cardBuilder.answerLabel': 'Type',

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'educationGoal',
    svg: 'future-goal-new-rc',
    title: 'Education',
    cardLabel: 'Education'
  }),
  educationGoalAmount: amountToBorrow,
  'educationGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.educationGoalAmount': `Goals: Education | ${amountToBorrow}`,
  educationGoalSavings: amountSaved,
  'educationGoalSavings.cardBuilder.answerLabel': saved,
  'details.educationGoalSavings': `Goals: Education | ${amountSaved}`,
  educationGoalTiming: loanTiming,
  'educationGoalTiming.0': loanTimingOptions.now,
  'educationGoalTiming.3': loanTimingOptions.three,
  'educationGoalTiming.6': loanTimingOptions.six,
  'educationGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.educationGoalTiming': `Goals: Education | ${loanTiming}`,
  'educationGoalWantsToBorrow': 'Do you wish to borrow?',
  'educationGoalWantsToBorrow.true': yes,
  'educationGoalWantsToBorrow.false': no,
  'details.educationGoalWantsToBorrow': `Goals: Education | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'vacationGoal',
    svg: 'future-goal-new-rc',
    title: 'Vacation / Travel',
    cardLabel: 'Vacation / Travel'
  }),
  vacationGoalAmount: amountToBorrow,
  'vacationGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.vacationGoalAmount': `Goals: Vacation | ${amountToBorrow}`,
  vacationGoalSavings: amountSaved,
  'vacationGoalSavings.cardBuilder.answerLabel': saved,
  'details.vacationGoalSavings': `Goals: Vacation | ${amountSaved}`,
  vacationGoalTiming: loanTiming,
  'vacationGoalTiming.0': loanTimingOptions.now,
  'vacationGoalTiming.3': loanTimingOptions.three,
  'vacationGoalTiming.6': loanTimingOptions.six,
  'vacationGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.vacationGoalTiming': `Goals: Vacation | ${loanTiming}`,
  'vacationGoalWantsToBorrow': 'Do you wish to borrow?',
  'vacationGoalWantsToBorrow.true': yes,
  'vacationGoalWantsToBorrow.false': no,
  'details.vacationGoalWantsToBorrow': `Goals: Life Event | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'lifeEventGoal',
    svg: 'future-goal-new-rc',
    title: 'Future Event (Holiday, Vacation, Wedding, etc.)',
    cardLabel: 'Future Event (Holiday, Vacation, Wedding, etc.)'
  }),
  lifeEventGoalAmount: amountToBorrow,
  'lifeEventGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.lifeEventGoalAmount': `Goals: Future Event | ${amountToBorrow}`,
  lifeEventGoalSavings: amountSaved,
  'lifeEventGoalSavings.cardBuilder.answerLabel': saved,
  'details.lifeEventGoalSavings': `Goals: Future Event | ${amountSaved}`,
  lifeEventGoalTiming: 'When do you want to withdraw the money?',
  'lifeEventGoalTiming.september': 'Check distributed in September',
  'lifeEventGoalTiming.date': 'Check distibuted on date of my choice',
  'lifeEventGoalTiming.neither': 'Neither, I do not want a check distribution',
  'lifeEventGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.lifeEventGoalTiming': `Goals: Future Event | ${loanTiming}`,
  'lifeEventGoalWantsToBorrow': 'Do you wish to borrow?',
  'lifeEventGoalWantsToBorrow.true': yes,
  'lifeEventGoalWantsToBorrow.false': no,
  'details.lifeEventGoalWantsToBorrow': `Goals: Life Event | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'debtConsolidationGoal',
    svg: 'debt-consolidation-new-rc',
    title: 'Pay-off debts',
    cardLabel: 'Pay-off debts'
  }),
  debtConsolidationGoalAmount: amountToBorrow,
  'debtConsolidationGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.debtConsolidationGoalAmount': `Goals: Pay-off debts | ${amountToBorrow}`,
  debtConsolidationGoalSavings: amountSaved,
  'debtConsolidationGoalSavings.cardBuilder.answerLabel': saved,
  'details.debtConsolidationGoalSavings': `Goals: Pay-off debts | ${amountSaved}`,
  debtConsolidationGoalTiming: loanTiming,
  'debtConsolidationGoalTiming.0': loanTimingOptions.now,
  'debtConsolidationGoalTiming.3': loanTimingOptions.three,
  'debtConsolidationGoalTiming.6': loanTimingOptions.six,
  'debtConsolidationGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.debtConsolidationGoalTiming': `Goals: Pay-off debts | ${loanTiming}`,
  'debtConsolidationGoalWantsToBorrow': 'Do you wish to borrow?',
  'debtConsolidationGoalWantsToBorrow.true': yes,
  'debtConsolidationGoalWantsToBorrow.false': no,
  'details.debtConsolidationGoalWantsToBorrow': `Goals: Pay-off debts | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'majorPurchaseGoal',
    svg: 'major-purchase-new-rc',
    title: 'Major Purchase',
    cardLabel: 'Major Purchase'
  }),
  majorPurchaseGoalAmount: amountToBorrow,
  'majorPurchaseGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.majorPurchaseGoalAmount': `Goals: Major Purchase | ${amountToBorrow}`,
  majorPurchaseGoalSavings: amountSaved,
  'majorPurchaseGoalSavings.cardBuilder.answerLabel': saved,
  'details.majorPurchaseGoalSavings': `Goals: Major Purchase | ${amountSaved}`,
  majorPurchaseGoalTiming: loanTiming,
  'majorPurchaseGoalTiming.0': loanTimingOptions.now,
  'majorPurchaseGoalTiming.3': loanTimingOptions.three,
  'majorPurchaseGoalTiming.6': loanTimingOptions.six,
  'majorPurchaseGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.majorPurchaseGoalTiming': `Goals: Major Purchase | ${loanTiming}`,
  majorPurchaseGoalAccess: loanAccess,
  'majorPurchaseGoalAccess.upFront': upFront,
  'majorPurchaseGoalAccess.overTime': overTime,
  'details.majorPurchaseGoalAccess': `Goals: Major Purchase | ${loanTiming}`,
  'majorPurchaseGoalWantsToBorrow': 'Do you wish to borrow?',
  'majorPurchaseGoalWantsToBorrow.true': yes,
  'majorPurchaseGoalWantsToBorrow.false': no,
  'details.majorPurchaseGoalWantsToBorrow': `Goals: Major Purchase | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'healthcareGoal',
    svg: 'healthcare-new-rc',
    title: 'Healthcare',
    cardLabel: 'Healthcare'
  }),
  healthcareGoalAmount: amountToBorrow,
  'healthcareGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.healthcareGoalAmount': `Goals: Healthcare | ${amountToBorrow}`,
  healthcareGoalSavings: amountSaved,
  'healthcareGoalSavings.cardBuilder.answerLabel': saved,
  'details.healthcareGoalSavings': `Goals: Healthcare | ${amountSaved}`,
  healthcareGoalTiming: loanTiming,
  'healthcareGoalTiming.0': loanTimingOptions.now,
  'healthcareGoalTiming.3': loanTimingOptions.three,
  'healthcareGoalTiming.6': loanTimingOptions.six,
  'healthcareGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.healthcareGoalTiming': `Goals: Healthcare | ${loanTiming}`,
  healthcareGoalAccess: loanAccess,
  'healthcareGoalAccess.upFront': upFront,
  'healthcareGoalAccess.overTime': overTime,
  'details.healthcareGoalAccess': `Goals: Major Purchase | ${loanTiming}`,
  'healthcareGoalWantsToBorrow': 'Do you wish to borrow?',
  'healthcareGoalWantsToBorrow.true': yes,
  'healthcareGoalWantsToBorrow.false': no,
  'details.healthcareGoalWantsToBorrow': `Goals: Health Care | ${ wantsToBorrow }`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'childSavingsGoal',
    svg: 'savings-new-rc',
    title: 'General Savings',
    cardLabel: 'General Savings'
  }),
  childSavingsGoalAmount: amountToBorrow,
  'childSavingsGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.childSavingsGoalAmount': `Goals: General Savings | ${amountToBorrow}`,
  childSavingsGoalSavings: amountSaved,
  'childSavingsGoalSavings.cardBuilder.answerLabel': saved,
  'details.childSavingsGoalSavings': `Goals: General Savings | ${amountSaved}`,
  childSavingsGoalTiming: loanTiming,
  'childSavingsGoalTiming.0': loanTimingOptions.now,
  'childSavingsGoalTiming.3': loanTimingOptions.three,
  'childSavingsGoalTiming.6': loanTimingOptions.six,
  'childSavingsGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.childSavingsGoalTiming': `Goals: General Savings | ${loanTiming}`,
  childSavingsGoalAccess: loanAccess,
  'childSavingsGoalAccess.upFront': upFront,
  'childSavingsGoalAccess.overTime': overTime,
  'details.childSavingsGoalAccess': `Goals: Major Purchase | ${loanTiming}`,
  'childSavingsGoalWantsToBorrow': 'Do you wish to borrow?',
  'childSavingsGoalWantsToBorrow.true': yes,
  'childSavingsGoalWantsToBorrow.false': no,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'rainyDayGoal',
    svg: 'bank-building',
    title: 'Save for Emergencies',
    cardLabel: 'Save for Emergencies'
  }),
  rainyDayGoalAmount: amountToBorrow,
  'rainyDayGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.rainyDayGoalAmount': `Goals: Save for Emergencies | ${amountToBorrow}`,
  rainyDayGoalSavings: amountSaved,
  'rainyDayGoalSavings.cardBuilder.answerLabel': saved,
  'details.rainyDayGoalSavings': `Goals: Save for Emergencies | ${amountSaved}`,
  rainyDayGoalTiming: loanTiming,
  'rainyDayGoalTiming.0': loanTimingOptions.now,
  'rainyDayGoalTiming.3': loanTimingOptions.three,
  'rainyDayGoalTiming.6': loanTimingOptions.six,
  'rainyDayGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.rainyDayGoalTiming': `Goals: Save for Emergencies | ${loanTiming}`,

  ...messagesForBuilder({
    appkey: 'goalTypes',
    goalId: 'otherGoal',
    svg: 'bank-building',
    title: 'Other Goal'
  }),
  otherGoalAmount: amountToBorrow,
  'otherGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.otherGoalAmount': `Goals: Other Goal | ${amountToBorrow}`,
  otherGoalTiming: loanTiming,
  'otherGoalTiming.0': loanTimingOptions.now,
  'otherGoalTiming.3': loanTimingOptions.three,
  'otherGoalTiming.6': loanTimingOptions.six,
  'otherGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.otherGoalTiming': `Goals: Other Goal | ${loanTiming}`,
  'otherGoalWantsToBorrow': 'Do you wish to borrow?',
  'otherGoalWantsToBorrow.true': yes,
  'otherGoalWantsToBorrow.false': no,
  'details.otherGoalWantsToBorrow': `Goals: Other | ${ wantsToBorrow }`,

  goalsAmountTotal: 'Total amount needed for goals:',
  goalsAmountTotalToBorrow: 'Total amount to borrow:',

  currentAccountsQuestionGroup: "Please tell me about your current finances to better personalize solutions for your needs.",
  'currentAccountsQuestionGroup.subtext': 'Add any current accounts that you have:',
  'currentAccountTypes.cardBuilder.addCard': 'Add Account',
  'currentAccountTypes.cardBuilder.removeCard': '<i class="fa fa-times-circle-o"></i>',
  'currentAccountTypes.cardBuilder.editCard': '<i class="fa fa-pencil-square-o"></i>',
  'currentAccountTypes.cardBuilder.modal.title': 'Select an an account type from the options below.',
  currentAccountTypes: 'Account Types:',

  ...messagesForBuilder({
    appkey: 'currentAccountTypes',
    goalId: 'checking',
    svg: 'checking-new-rc',
    title: 'Checking'
  }),
  checkingBalance: currentAccount_amount,
  'details.checkingBalance': `Current checking account | ${currentAccount_amount}`,
  checkingBalanceOtherBank: currentAccount_otherBankAmount,
  'details.checkingBalanceOtherBank': `Current checking account | ${currentAccount_otherBankAmount}`,
  checkingBalanceAmountToMovePct: currentAccount_willingToMove,
  'details.checkingBalanceAmountToMovePct': `Current checking account | ${currentAccount_willingToMove}`,
  'checkingBalance.cardBuilder.answerLabel': amount,
  'checkingBalanceOtherBank.cardBuilder.answerLabel': amountOther,
  'checkingBalanceAmountToMovePct.cardBuilder.answerLabel': moving,
  checkingBalanceAmountToMove: `Checking ${currentAccount_willingToMoveDollars}`,
  directDepositAmount: 'What is the total amount of direct deposits to your checking each month ($)?',

  ...messagesForBuilder({
    appkey: 'currentAccountTypes',
    goalId: 'savings',
    svg: 'savings-new-rc',
    title: 'Savings and Money Markets'
  }),
  savingsBalance: currentAccount_amount,
  'details.savingsBalance': `Current savings account | ${currentAccount_amount}`,
  savingsBalanceOtherBank: currentAccount_otherBankAmount,
  'details.savingsBalanceOtherBank': `Current savings account | ${currentAccount_otherBankAmount}`,
  savingsBalanceAmountToMovePct: currentAccount_willingToMove,
  'details.savingsBalanceAmountToMovePct': `Current savings account | ${currentAccount_willingToMove}`,
  'savingsBalance.cardBuilder.answerLabel': amount,
  'savingsBalanceOtherBank.cardBuilder.answerLabel': amountOther,
  'savingsBalanceAmountToMovePct.cardBuilder.answerLabel': moving,
  savingsBalanceAmountToMove: `Savings ${currentAccount_willingToMoveDollars}`,

  ...messagesForBuilder({
    appkey: 'currentAccountTypes',
    goalId: 'cd',
    svg: 'bank-building-new-rc',
    title: 'Certificates of Deposit'
  }),
  cdBalance: currentAccount_amount,
  'details.cdBalance': `Current CD account | ${currentAccount_amount}`,
  cdBalanceOtherBank: currentAccount_otherBankAmount,
  'details.cdBalanceOtherBank': `Current CD account | ${currentAccount_otherBankAmount}`,
  cdBalanceAmountToMovePct: currentAccount_willingToMove,
  'details.cdBalanceAmountToMovePct': `Current CD account | ${currentAccount_willingToMove}`,
  'cdBalance.cardBuilder.answerLabel': amount,
  'cdBalanceOtherBank.cardBuilder.answerLabel': amountOther,
  'cdBalanceAmountToMovePct.cardBuilder.answerLabel': moving,
  cdBalanceAmountToMove: `CD ${currentAccount_willingToMoveDollars}`,

  ...messagesForBuilder({
    appkey: 'currentAccountTypes',
    goalId: 'loans',
    svg: 'loan-new-rc',
    title: 'Loans and Lines of Credit'
  }),
  loanTypes: 'What other types of loans do you have:',
  'loanTypes.cardBuilder.answerLabel': 'Types',
  loansBalance: 'With S<span id="ampersand">&</span>T ($)',
  'loansBalance.cardBuilder.answerLabel': 'Balance',
  loansBalanceOtherBank: 'With Other Banks ($)',
  'loansBalanceOtherBank.cardBuilder.answerLabel': 'Balance',
  loansBalanceAmountToMovePct: 'Amount to move',
  'loansBalanceAmountToMovePct.cardBuilder.answerLabel': 'Percent',
  loansBalanceAmountToMove: 'Amount to move',
  'loansBalanceAmountToMove.cardBuilder.answerLabel': 'Amount',

  depositAccountsTotal: 'Deposit account(s) balance:',

  checkingAccountQuestionGroup: 'How would you describe your banking activity each month?',
  'checkingAccountQuestionGroup.subtext': 'Checking Account(s)',
  checksWritten: 'Checks written (#):',
  'checksWritten.input.placeholder': '',
  debitUsage: 'Debit cards (#):',
  'debitUsage.input.placeholder': '',
  onlineBankingBillsPaid: 'Pay bills through online banking (#):',
  'onlineBankingBillsPaid.input.placeholder': '',
  atmUsage: 'Withdrawals from S<span id="ampersand">&</span>T Bank ATMs (#):',
  'atmUsage.input.placeholder': '',
  atmUsageOther: 'Withdrawals from Other Financial Institution ATMs (Non-S<span id="ampersand">&</span>T) (#):',
  'atmUsageOther.input.placeholder': '',

  savingsAccountQuestionGroup: 'How would you describe your banking activity each month?',
  'savingsAccountQuestionGroup.subtext': 'Savings Account(s)',
  savingsDepositFrequency: 'Deposits (#):',
  savingsWithdrawalFrequency: 'Withdrawals (#):',
  savingsAtmFrequency: 'Withdrawals from S<span id="ampersand">&</span>T Bank ATMs (#):',
  savingsAtmFrequencyOther: 'Withdrawals from Other Financial Institution ATMs (Non-S<span id="ampersand">&</span>T) (#):',

  cdPreference: 'Are you interested in either of these options for a Certificate of Deposit account?',
  'cdPreference.subtext': selectAll,
  'cdPreference.withdraw': 'Ability to withdraw funds prior to maturity',
  'cdPreference.withdraw.subtext': 'Early Withdrawal',
  'cdPreference.deposit': 'Depositing additional funds prior to maturity',
  'cdPreference.deposit.subtext': 'Additional Deposits',
  'cdPreference.none': 'I am not interested in any of the available options',
  'cdPreference.none.subtext': 'Neither',

  electronicStatements: 'Which type of statements do you prefer for your savings account?',
  'electronicStatements.electronic': 'Electronic statements',
  'electronicStatements.electronic.subtext': 'Digital',
  'electronicStatements.paper': 'Printed, quarterly statements',
  'electronicStatements.paper.subtext': 'Paper',
  'electronicStatements.passbook': 'I prefer having a Passbook',
  'electronicStatements.passbook.subtext': 'Passbook',

  wantsInterest: 'Would you say that earning interest is a top priority for you?',
  'wantsInterest.true': yes,
  'wantsInterest.true.icon': yes_icon,
  'wantsInterest.false': 'No preference',
  'wantsInterest.false.icon': no_icon,

  basicCheckingPreference: 'It sounds like a basic checking account would fit you best. Which of these options appeal to you the most?',
  'basicCheckingPreference.select': '<h4>Unlimited check writing</h4> No monthly service charge, Overdraft fees apply as applicable, Ability to write unlimited checks and use debit card',
  'details.basicCheckingPreference.select': 'No monthly service charge, Overdraft fees apply as applicable, Ability to write unlimited checks and use debit card',
  'basicCheckingPreference.select.icon': '/classpath/assets/images/checking-easy.svg',
  'basicCheckingPreference.easy': '<h4>Checkless</h4> Low fixed monthly fee, No overdraft fees, No-fee debit card, no checks',
  'details.basicCheckingPreference.easy': 'Low fixed monthly fee, No overdraft fees, No-fee debit card, no checks',
  'basicCheckingPreference.easy.icon': '/classpath/assets/images/checking-select.svg',

  ownershipStatus: 'Do you currently own or rent your home?',
  'ownershipStatus.rent': 'Rent',
  'ownershipStatus.own': 'Own',
  'ownershipStatus.other': 'Living with friends or relatives',

  homeValueQuestionGroup: 'Can you tell us more about your home?',
  homeValue: 'What is the estimated value of the home you own:',
  mortgageBalance: 'How much do you owe on your home, if any:',
  homeEquityAmountAvailable: 'Home equity available:',

  useHomeEquity: 'Would you like to use your home equity to borrow towards your goals?',
  'useHomeEquity.debtConsolidationGoal': 'Pay-off debts',
  'useHomeEquity.educationGoal': 'Education',
  'useHomeEquity.healthcareGoal': 'Healthcare',
  'useHomeEquity.homeGoal': 'Purchase / Refinance Home',
  'useHomeEquity.homeImprovementGoal': 'Home Improvements',
  'useHomeEquity.refinanceHomeGoal': 'Refinance a Home',
  'useHomeEquity.retirementGoal': 'Retirement',
  'useHomeEquity.childSavingsGoal': 'General Savings',
  'useHomeEquity.vacationGoal': 'Vacation / Travel',
  'useHomeEquity.vehicleGoal': 'Purchase / Refinance Vehicle',
  'useHomeEquity.majorPurchaseGoal': 'Major Purchase',
  'useHomeEquity.lifeEventGoal': 'Future Event (Holiday, Vacation, Wedding, etc.)',
  'useHomeEquity.rainyDayGoal': 'Save for Emergencies',
  'useHomeEquity.otherGoal': 'Other',
  'useHomeEquity.none': 'No, thank you',

  homeEquityAmountTotal: 'Home Equity Available: ',
  homeEquityAmountToBorrow: 'Selected Equity Amount to Borrow: ',

  wantsCreditCard: 'Do you currently use credit cards or would like to?',
  'wantsCreditCard.true': yes,
  'wantsCreditCard.true.icon': yes_icon,
  'wantsCreditCard.false': no,
  'wantsCreditCard.false.icon': no_icon,

  creditCardUsageQuestionGroup: 'Tell us about your credit card usage.',
  creditCardUsage: 'How do / would you like to use your credit card(s)?',
  'creditCardUsage.subtext': selectAll,
  'creditCardUsage.dayPurchases': 'Everyday purchases',
  'creditCardUsage.travel': 'Travel',
  'creditCardUsage.buildCredit': 'Build / rebuild credit',
  'creditCardUsage.balanceTransfer': 'Transfer balance to consolidate debt',
  'creditCardUsage.college': 'College purchases or expenses',

  creditCardFeatures: "Which type of card do you prefer?",
  'creditCardFeatures.lowInterest': 'Low interest rate',
  'creditCardFeatures.cashRewards': 'Cash rewards',
  'creditCardFeatures.rewards': 'Reward points to use towards gift cards, travel and merchandise',

  creditCardTravel: 'Would you be willing to pay an annual fee if TSA Pre-check or Global Entry fees were reimbursed to your account?',
  'creditCardTravel.true': yes,
  'creditCardTravel.true.icon': yes_icon,
  'creditCardTravel.false': no,
  'creditCardTravel.false.icon': no_icon,

  homeOwnerStatus: 'Can you tell me a little more about yourself? We may have unique options for you.',
  'homeOwnerStatus.subtext': selectAll,
  'homeOwnerStatus.veteran': 'A veteran or currently enlisted in the military',
  'homeOwnerStatus.veteran.subtext': 'Veteran / Active Military',
  'homeOwnerStatus.first': 'Interested or in the process of buying first home',
  'homeOwnerStatus.first.subtext': 'Buying First Home',
  'homeOwnerStatus.none': 'None of the above',
  'homeOwnerStatus.none.subtext': 'Neither of the topics above apply to me',

  otherGoalsAccount: 'May we discuss any other goals you have today?',
  'otherGoalsAccount.true': yes,
  'otherGoalsAccount.false': no,

  otherGoalsCC: 'May we discuss any other goals you have today?',
  'otherGoalsCC.true': yes,
  'otherGoalsCC.false': no,

  otherGoals: 'May we discuss any other goals you have today?',
  'otherGoals.true': yes,
  'otherGoals.false': no,

  ageBasedBenefits: 'Are you interested in the amazing benefits S<span id="ampersand">&</span>T Bank offers for a child or grandchild under 24 years of age?',
  'ageBasedBenefits.subtext': selectAll,
  'ageBasedBenefits.younger': 'Yes, for someone under 13',
  'ageBasedBenefits.older': 'Yes, for someone between 14-24',
  'ageBasedBenefits.none': 'No, thank you',

  demographicsQuestionGroup: 'A bit more about you:',
  age: 'What is your age?',
  'age.input.placeholder': 'Enter your age',
  postalCode: 'Where do you live?',
  'postalCode.input.placeholder': 'Enter your zip code',

  militaryService: 'Are you a Veteran or Active Military?',
  'militaryService.true': 'Yes',
  'militaryService.false': 'No',

  /**
   * ============================
   * PRODUCT MESSAGES
   * ============================
   */
  '17000.name': 'Preferred Banking',
  '17000.url': 'https://www.stbank.com/personal/bank/checking/preferred/',
  '17000.description.abbreviated': 'The preferred, personal checking option, complete with debit rewards so your spending pays back.',
  '17000.description': '',
  '17000.features.count': 3,
  '17000.features.1': 'No monthly maintenance fee if balance requirements are met',
  '17000.features.2': 'Cash Back Rewards available',
  '17000.features.3': 'Free ATMs anywhere',
  '17000.whyBest.1.message': 'S<span id="ampersand">&</span>T Bank VISA debit card',
  '17000.whyBest.2.message': 'Online and Mobile banking',
  '17000.whyBest.3.message': 'Online statements',
  '17000.whyBest.4.message': 'First order of checks',
  '17000.whyBest.5.message': 'Overdraft options available',
  '17000.disclosures.count': 5,
  '17000.disclosures.1': 'Must maintain minimum daily balance of $1,000 required in Preferred Banking checking account or combined deposit balance and home loan outstanding balance of $25,000 or more 7, Otherwise a $10 monthly maintenance fee if one of the above balances is not met. Combined home loan balances include outstanding balances on mortgage loans serviced by S<span id="ampersand">&</span>T Bank, home equity loan and home equity line of credit outstanding balances. Home loan balances do not include VA, FHA, or PHFA mortgages.',
  '17000.disclosures.2': '$.05 credited to your account for every credit or signature based transaction made with your Preferred Banking debit card. The total debit reward incentive will be subject to 1099 reporting.',
  '17000.disclosures.3': 'First order of Preferred Banking checks are free to new Preferred Banking accounts only and not to converted accounts.',
  '17000.disclosures.4': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',
  '17000.disclosures.5': 'Unlimited free ATM transactions at S<span id="ampersand">&</span>T Bank ATMs. S<span id="ampersand">&</span>T Bank does not charge you to use another bank\'s ATM plus reimburses surcharge fees (fees charged by other banks to use their ATMs) per statement cycle. Free ATM transactions do not apply to any fees other than fees assessed for using an ATM to withdraw cash from your S<span id="ampersand">&</span>T Armed Forces Account; for example, the VISA International Service Assessment Fee, that applies when a foreign country ATM is used for a cash withdrawal, is not waived or reimbursed, and will continue to apply.',

  '17001.name': 'Preferred Banking with Interest',
  '17001.url': 'https://www.stbank.com/personal/bank/checking/preferred/',
  '17001.description.abbreviated': 'Perfect for those with a busy and active lifestyle that need a bank account that works as hard as they do.',
  '17001.description': '',
  '17001.features.count': 3,
  '17001.features.1': 'Competitive interest rates',
  '17001.features.2': 'No monthly maintenance fee is balance requirements are met',
  '17001.features.3': 'Free ATMs anywhere',
  '17001.whyBest.1.message': 'S<span id="ampersand">&</span>T Bank VISA debit card',
  '17001.whyBest.2.message': 'Online and Mobile banking',
  '17001.whyBest.3.message': 'Online statements',
  '17001.whyBest.4.message': 'First order of checks',
  '17001.whyBest.5.message': 'Overdraft options available',
  '17001.disclosures.count': 5,
  '17001.disclosures.1': 'Preferred Banking with Interest is a variable rate account and your interest rate and Annual Percentage Yield may change at the Bank\'s discretion without prior notice. Rates may change at any time.',
  '17001.disclosures.2': 'Must maintain minimum daily balance of $1,000 required in Preferred Banking checking account or combined deposit balance and home loan outstanding balance of $50,000 or more, otherwise a $15 monthly maintenance fee if one of the above balances is not met. Combined home loan balances include outstanding balances on mortgage loans serviced by S<span id="ampersand">&</span>T Bank, home equity loan and home equity line of credit outstanding balances. Home loan balances do not include VA, FHA, or PHFA mortgages.',
  '17001.disclosures.3': '$.05 credited to your account for every credit or signature based transaction made with your Preferred Banking debit card. The total debit reward incentive will be subject to 1099 reporting.',
  '17001.disclosures.4': 'First order of Preferred Banking checks are free to new Preferred Banking accounts only and not to converted accounts.',
  '17001.disclosures.5': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17002.name': 'Four Star Banking with Interest',
  '17002.url': 'https://www.stbank.com/personal/bank/checking/four-star/',
  '17002.description.abbreviated': 'At S<span id="ampersand">&</span>T, age comes with benefits. For those 50+, you can enjoy overdraft protection, free statements, and variable interest rates.',
  '17002.description': '',
  '17002.features.count': 3,
  '17002.features.1': 'Free Paper and Online Statements',
  '17002.features.2': 'No monthly maintenance fee if balance requirements are met',
  '17002.features.3': 'Free Clubline checks',
  '17002.whyBest.1.message': 'Competitive Interest Rates',
  '17002.whyBest.2.message': 'S<span id="ampersand">&</span>T Bank VISA debit card',
  '17002.whyBest.3.message': 'Unlimited ATM transactions at S<span id="ampersand">&</span>T Bank ATMs',
  '17002.whyBest.4.message': 'Online and Mobile banking',
  '17002.whyBest.5.message': 'Loss Key prevention available',
  '17002.whyBest.6.message': 'Overdraft options available',
  '17002.whyBest.7.message': 'No penalty withdraws CDs for health-related emergencies',
  '17002.whyBest.8.message': '50% Discount on Safe Deposit Box',
  '17002.whyBest.9.message': '10% discount on S<span id="ampersand">&</span>T Wealth Management\'s trust services’ first-year fees',
  '17002.disclosures.count': 3,
  '17002.disclosures.1': 'Four Star Banking with Interest is a variable rate account and your interest rate and Annual Percentage Yield may change at the Bank\'s discretion without prior notice. Rates may change at any time. ',
  '17002.disclosures.2': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information.',
  '17002.disclosures.3': 'Must maintain minimum daily balance of $1,000 in Four Star Banking checking account or combined deposit balance and home loan outstanding balance of $5,000 or more 7, Otherwise a $10 monthly maintenance fee if one of the above balances is not met. Combined home loan balances include outstanding balances on mortgage loans serviced by S<span id="ampersand">&</span>T Bank, home equity loan and home equity line of credit outstanding balances. Home loan balances do not include VA, FHA, or PHFA mortgages',

  '17003.name': 'Interest Checking',
  '17003.url': 'https://www.stbank.com/personal/bank/checking/interest/',
  '17003.description.abbreviated': 'Put your money to work and earn interest on your checking account balance.',
  '17003.description': '',
  '17003.features.count': 2,
  '17003.features.1': 'No monthly maintenance fee if balance requirements are met',
  '17003.features.2': 'Competitive variable interest rates',
  '17003.whyBest.1.message': 'S<span id="ampersand">&</span>T Bank VISA debit card',
  '17003.whyBest.2.message': 'Unlimited ATM transactions at S<span id="ampersand">&</span>T Bank ATMs',
  '17003.whyBest.3.message': 'Online and Mobile banking',
  '17003.whyBest.4.message': 'Online statements',
  '17003.whyBest.5.message': 'Overdraft options available',
  '17003.disclosures.count': 3,
  '17003.disclosures.1': 'Rates are variable and may change after account opening. Fees could reduce earnings.',
  '17003.disclosures.2': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information.',
  '17003.disclosures.3': 'Must maintain minimum daily balance of $1,000 or $2,500 average Interest checking  or combined deposit balance and home loan outstanding balance of $20,000 or more 7, Otherwise a $10 monthly maintenance fee if one of the above balances is not met. ',

  '17004.name': 'Armed Forces Account',
  '17004.url': 'https://www.stbank.com/',
  '17004.description.abbreviated': 'You\'ve served our country, now it’s S<span id="ampersand">&</span>T\'s turn to serve you. That is why we are proud to offer this product, specifically designed for those who are in the military, with no minimum balance and no monthly service charge.',
  '17004.description': '',
  '17004.features.count': 3,
  '17004.features.1': 'No minimum balance requirement',
  '17004.features.2': 'No monthly maintenance fees',
  '17004.features.3': 'Free ATMs anywhere',
  '17004.whyBest.1.message': 'Wire transfers',
  '17004.whyBest.2.message': 'Money orders',
  '17004.whyBest.3.message': 'Checks',
  '17004.whyBest.4.message': 'Online and Mobile banking',
  '17004.whyBest.5.message': 'Visa debit card or ATM card',
  '17004.whyBest.6.message': 'Safe deposit box',
  '17004.whyBest.7.message': 'Online and paper statements',
  '17004.whyBest.8.message': 'Overdraft options available',
  '17004.disclosures.count': 3,
  '17004.disclosures.1': 'The Armed Forces Account is a checking account for individuals with a valid military ID. $50 minimum opening balance requirement. Refer to S<span id="ampersand">&</span>T Consumer Fee Schedule for additional details.',
  '17004.disclosures.2': 'Unlimited free ATM transactions at S<span id="ampersand">&</span>T Bank ATMs. S<span id="ampersand">&</span>T Bank does not charge you to use another bank’s ATM plus reimburses surcharge fees (fees charged by other banks to use their ATMs) per statement cycle. Free ATM transactions do not apply to any fees other than fees assessed for using an ATM to withdraw cash from your S<span id="ampersand">&</span>T Armed Forces Account; for example, the VISA International Service Assessment Fee, that applies when a foreign country ATM is used for a cash withdrawal, is not waived or reimbursed, and will continue to apply.',
  '17004.disclosures.3': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17005.name': 'Four Star Banking',
  '17005.url': 'https://www.stbank.com/personal/bank/checking/four-star/',
  '17005.description.abbreviated': 'The best choice for 50+ with unique benefits, like overdraft protection, free statements and more.',
  '17005.description': '',
  '17005.features.count': 3,
  '17005.features.1': 'Free Paper and Online Statements',
  '17005.features.2': 'No monthly maintenance fee if balance requirements are met',
  '17005.features.3': 'Free Clubline checks',
  '17005.whyBest.1.message': 'S<span id="ampersand">&</span>T Bank VISA debit card',
  '17005.whyBest.2.message': 'Unlimited atm transactions at S<span id="ampersand">&</span>T Bank ATMs',
  '17005.whyBest.3.message': 'Online and Mobile banking',
  '17005.whyBest.4.message': 'Loss Key prevention available',
  '17005.whyBest.5.message': 'Overdraft options available',
  '17005.whyBest.6.message': 'No penalty withdraws CDs for health-related emergencies',
  '17005.whyBest.7.message': '50% Discount on Safe Deposit Box',
  '17005.whyBest.8.message': '10% discount on S<span id="ampersand">&</span>T Wealth Management\'s trust services’ first-year fees',
  '17005.disclosures.count': 2,
  '17005.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information.',
  '17005.disclosures.2': 'Must maintain minimum daily balance of $1,000 in Four Star Banking checking account or combined deposit balance and home loan outstanding balance of $5,000 or more 7, Otherwise a $10 monthly maintenance fee if one of the above balances is not met. Combined home loan balances include outstanding balances on mortgage loans serviced by S<span id="ampersand">&</span>T Bank, home equity loan and home equity line of credit outstanding balances. Home loan balances do not include VA, FHA, or PHFA mortgages',

  '17006.name': 'Select Banking',
  '17006.url': 'https://www.stbank.com/personal/bank/checking/select/',
  '17006.description.abbreviated': 'Perfect for the cost-conscious, this simple checking account has no monthly fees.',
  '17006.description': '',
  '17006.features.count': 2,
  '17006.features.1': 'No minimum balance',
  '17006.features.2': 'No monthly maintenance fees',
  '17006.whyBest.1.message': 'Visa debit card or ATM card',
  '17006.whyBest.2.message': 'Online and Mobile banking',
  '17006.whyBest.3.message': 'ATM banking at S<span id="ampersand">&</span>T Bank ATMs',
  '17006.whyBest.4.message': 'Online statements',
  '17006.whyBest.5.message': 'Overdraft options available',
  '17006.whyBest.6.message': 'Email and text alerts',
  '17006.whyBest.7.message': 'Online statements',
  '17006.disclosures.count': 1,
  '17006.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information.',

  '17007.name': 'Easy Banking',
  '17007.url': 'https://www.stbank.com/personal/bank/checking/easy/',
  '17007.description.abbreviated': 'A no-hassle, checkless account that skips the overdraft fees.',
  '17007.description': '',
  '17007.features.count': 3,
  '17007.features.1': 'No overdraft fees',
  '17007.features.2': 'No minimum daily balance required',
  '17007.features.3': 'No paper statement fee',
  '17007.whyBest.1.message': 'Online banking with bill pay',
  '17007.whyBest.2.message': 'POS debit card',
  '17007.whyBest.3.message': 'Unlimited ATM transactions at S<span id="ampersand">&</span>T Bank ATMs',
  '17007.disclosures.count': 3,
  '17007.disclosures.1': '$5 Monthly maintenance fee applies',
  '17007.disclosures.2': 'No checks will be allowed; If check is presented for payment it will be returned and not honored',
  '17007.disclosures.3': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17008.name': 'Smart Start Banking',
  '17008.url': 'https://www.stbank.com/personal/bank/checking/smart-start/',
  '17008.description.abbreviated': 'Designed for students and teens to dive confidently into the world of personal finance.',
  '17008.description': '',
  '17008.features.count': 3,
  '17008.features.1': 'No minimum daily balance required',
  '17008.features.2': 'No monthly maintenance fees',
  '17008.features.3': 'Free ATMs anywhere',
  '17008.whyBest.1.message': 'Wire transfers',
  '17008.whyBest.2.message': 'Money orders',
  '17008.whyBest.3.message': 'Online and Mobile banking',
  '17008.whyBest.4.message': 'S<span id="ampersand">&</span>T Bank Visa debit card ',
  '17008.whyBest.5.message': 'First order of checks',
  '17008.whyBest.6.message': 'Online statements',
  '17008.whyBest.7.message': 'Scholarship opportunity available',
  '17008.disclosures.count': 1,
  '17008.disclosures.1': 'Employees of S<span id="ampersand">&</span>T Bank, its affiliates, subsidiaries, dealers, distributors, retailers, advertising and production agencies, their immediate families, and those living in the same household are not eligible to apply for the scholarship. S<span id="ampersand">&</span>T Bank may suspend, change or terminate this program at any time. The interpretation, application and administration of the program shall be determined by the Student Scholarship Committee, whose decision is final.',
  '17008.disclosures.2': '2.	Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',
  '17008.disclosures.3': '3.	Unlimited free ATM transactions at S<span id="ampersand">&</span>T Bank ATMs. S<span id="ampersand">&</span>T Bank does not charge you to use another bank’s ATM plus reimburses surcharge fees (fees charged by other banks to use their ATMs) per statement cycle. Free ATM transactions do not apply to any fees other than fees assessed for using an ATM to withdraw cash from your S<span id="ampersand">&</span>T Armed Forces Account; for example, the VISA International Service Assessment Fee, that applies when a foreign country ATM is used for a cash withdrawal, is not waived or reimbursed, and will continue to apply',

  '17009.name': 'Moola Moola Passbook Savings Account',
  '17009.url': 'https://www.stbank.com/personal/bank/savings/moola-moola/',
  '17009.description.abbreviated': 'This special passbook savings club teaches children age 13 and under all about saving.',
  '17009.description': '',
  '17009.features.count': 3,
  '17009.features.1': 'Tier prized levels are awarded as balances grow',
  '17009.features.2': 'Interest earned daily',
  '17009.features.3': 'Unlimited transactions at any S<span id="ampersand">&</span>T branch',
  '17009.whyBest.1.message': 'Online and Mobile banking',
  '17009.whyBest.2.message': 'Passbook',
  '17009.disclosures.count': 4,
  '17009.disclosures.1': 'Passbook must be present to conduct transaction',
  '17009.disclosures.2': 'Funds cannot be transferred out of the account – a form must be completed to establish this transfer',
  '17009.disclosures.3': 'Quarterly maintenance fee waived for minors. $10 quarterly maintenance fee assessed upon account holder’s 18th birthday if minimum balance falls below $200 ',
  '17009.disclosures.4': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17010.name': 'Minor Statement Savings',
  '17010.url': 'https://www.stbank.com/',
  '17010.description.abbreviated': 'This simple savings account is perfect for children aged 14-18',
  '17010.description': '',
  '17010.features.count': 2,
  '17010.features.1': 'No maintenance fee for children under 18',
  '17010.features.2': 'No maintenance fee if minimum requirements are met over 18',
  '17010.whyBest.1.message': 'Online banking',
  '17010.whyBest.2.message': 'Mobile banking',
  '17010.whyBest.3.message': 'Unlimited deposits and withdrawals performed at a branch',
  '17010.disclosures.count': 0,

  '17011.name': 'Preferred Savings',
  '17011.url': 'https://www.stbank.com/personal/bank/savings/preferred-savings/',
  '17011.description.abbreviated': 'The perfect choice for high-yield savings for those with Preferred Banking.',
  '17011.description': '',
  '17011.features.count': 3,
  '17011.features.1': 'No quarterly maintenance fee if balance requirements are met',
  '17011.features.2': 'Quarterly statements provided',
  '17011.features.3': 'Higher variable interest rates',
  '17011.whyBest.1.message': 'Online and Mobile banking',
  '17011.whyBest.2.message': 'Unlimited deposits and withdrawals performed at a branch',
  '17011.disclosures.count': 3,
  '17011.disclosures.1': 'This is a variable rate account and your interest rate and Annual Percentage Yield (APY) may change at the Bank’s discretion without prior notice. Customer must have Preferred Banking in order to qualify for Preferred Savings. Quarterly interest plan. One Preferred Savings per Preferred Banking household. Rates may change at any time.',
  '17011.disclosures.2': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',
  '17011.disclosures.3': '$10 quarterly maintenance fee applies if $200 minimum daily balance requirements are not met.',

  '17012.name': 'Statement Savings',
  '17012.url': 'https://www.stbank.com/personal/bank/savings/statement/',
  '17012.description.abbreviated': 'Get savings simplicity with variable interest rates and 24/7 access to your funds.',
  '17012.description': '',
  '17012.features.count': 3,
  '17012.features.1': 'No monthly maintenance fee if balance requirements are met',
  '17012.features.2': 'Quarterly statements provided',
  '17012.features.3': 'Variable tiered interest rates',
  '17012.whyBest.1.message': 'ATM card',
  '17012.whyBest.2.message': 'Online and Mobile banking',
  '17012.whyBest.3.message': 'Unlimited deposits and withdrawals performed at a branch',
  '17012.disclosures.count': 2,
  '17012.disclosures.1': '$10 quarterly maintenance fee applies if $200 minimum daily balance requirements are not met.',
  '17012.disclosures.2': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17013.name': 'Passbook Savings',
  '17013.url': 'https://www.stbank.com/',
  '17013.description.abbreviated': 'Designed for individuals that desire a savings account with a passbook to track account activity.',
  '17013.description': '',
  '17013.features.count': 2,
  '17013.features.1': 'No monthly maintenance fee if balance requirements are met',
  '17013.features.2': 'Variable interest rates',
  '17013.whyBest.1.message': 'a.	Online and Mobile banking',
  '17013.whyBest.2.message': 'b.	Passbook',
  '17013.whyBest.3.message': 'c.	Unlimited deposits and withdrawals performed at a branch',
  '17013.whyBest.4.message': 'Mobile banking',
  '17013.disclosures.count': 4,
  '17013.disclosures.1': 'Passbook must be present to conduct transaction',
  '17013.disclosures.2': 'Funds cannot be transferred out of the account – a form must be completed to establish this transfer',
  '17013.disclosures.3': '$10 quarterly maintenance fee applies if $200 minimum daily balance requirements are not met.',
  '17013.disclosures.4': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17014.name': 'Premium Holiday Club',
  '17014.url': 'https://www.stbank.com/personal/bank/savings/holiday-club/',
  '17014.description.abbreviated': 'Make holiday savings simple with automatic deductions from your S<span id="ampersand">&</span>T checking or savings account.',
  '17014.description': '',
  '17014.features.count': 3,
  '17014.features.1': 'Ability to disburse funds at the end of September on a yearly basis',
  '17014.features.2': 'Premium variable interest rate',
  '17014.features.3': 'Recurring transfers from your deposit account',
  '17014.whyBest.1.message': 'Online and Mobile banking',
  '17014.whyBest.2.message': 'Unlimited deposits performed at a branch',
  '17014.disclosures.count': 2,
  '17014.disclosures.1': 'This is a variable rate account and your interest rate and Annual Percentage Yield may change at the Bank\'s discretion without prior notice. This account requires direct deposit of contributions and direct deposit of funds to your S<span id="ampersand">&</span>T account. If direct deposit of funds ceases, account will be closed. No withdrawals will be permitted prior to disbursement. Rates may change at any time.',
  '17014.disclosures.2': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17015.name': 'My Choice Account',
  '17015.url': 'https://www.stbank.com/personal/bank/savings/my-choice/',
  '17015.description.abbreviated': 'This savings choice for any occasion enables you to pick the perfect timeline for your life plans.',
  '17015.description': '',
  '17015.features.count': 3,
  '17015.features.1': 'Ability to disburse funds on your chosen date on a yearly basis',
  '17015.features.2': 'Premium variable interest rate',
  '17015.features.3': 'Recurring transfers from your deposit account',
  '17015.whyBest.1.message': 'Online and Mobile banking',
  '17015.whyBest.2.message': 'Unlimited deposits and withdrawals performed at a branch',
  '17015.disclosures.count': 2,
  '17015.disclosures.1': 'This is a variable rate account and your interest rate and Annual Percentage Yield may change at the Bank\'s discretion without prior notice. This account requires direct deposit of contributions and direct deposit of funds to your S<span id="ampersand">&</span>T account. If direct deposit of funds ceases, account will be closed. Interest is credited once per year on the date selected by customer. If the account is closed before interest is credited, all accrued interest in the account may be forfeited. Once a disbursement date is',
  '17015.disclosures.2': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information.',

  '17016.name': 'Money Market',
  '17016.url': 'https://www.stbank.com/personal/bank/savings/money-market/',
  '17016.description.abbreviated': 'Make unlimited over-the-counter transactions and get a competitive yield on your savings.',
  '17016.description': '',
  '17016.features.count': 1,
  '17016.features.1': 'Variable tiered interest rate',
  '17016.whyBest.1.message': 'Online and Mobile banking',
  '17016.whyBest.2.message': 'Unlimited deposits performed at a branch',
  '17016.whyBest.3.message': 'Overdraft options available',
  '17016.disclosures.count': 3,
  '17016.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',
  '17016.disclosures.2': 'A maximum of six third party transactions are permitted per calendar month or statement cycle',
  '17016.disclosures.3': '$10 monthly maintenance fee applies if minimum daily balance of at least $1,000 or monthly average balance of $2,500 or Combined deposit and home loan balances of $20,000* or more requirement is not met. Combined home loan balances include outstanding balances on mortgage loans serviced by S<span id="ampersand">&</span>T Bank, home equity loan and home equity line of credit outstanding balances. Home loan balances do not include VA, FHA, or PHFA mortgages.',

  '17017.name': 'Rate Tracker',
  '17017.url': 'https://www.stbank.com/personal/banks/savings/rate-tracker/',
  '17017.description.abbreviated': 'An indexed money market account that is based on 75% of the Upper Bound Feds Funds Target Rate.',
  '17017.description': '',
  '17017.features.count': 3,
  '17017.features.1': 'Variable tiered interest rate',
  '17017.features.2': 'Based on Upper Bound Fed Funds target rate',
  '17017.features.3': 'No minimum fee if balance requirements are met',
  '17017.whyBest.1.message': 'Online and Mobile banking',
  '17017.whyBest.2.message': 'Unlimited deposits and withdrawals performed at a branch',
  '17017.disclosures.count': 3,
  '17017.disclosures.1': 'A maximum of six third party transactions are permitted per calendar month or statement cycle',
  '17017.disclosures.2': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',
  '17017.disclosures.3': '15 monthly maintenance fee applies if $10,000 minimum daily balance requirements is not met.',

  '17018.name': 'Cash Management Account',
  '17018.url': 'https://www.stbank.com/',
  '17018.description.abbreviated': 'With a variable tiered interest rate, this account is for those looking to earn on their savings.',
  '17018.description': '',
  '17018.features.count': 2,
  '17018.features.1': 'Variable tiered interest rate',
  '17018.features.2': 'No maintenance fee if balance requirements are met',
  '17018.whyBest.1.message': 'Online and Mobile banking',
  '17018.whyBest.2.message': 'Online or paper statements',
  '17018.disclosures.count': 3,
  '17018.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',
  '17018.disclosures.2': 'Excessive transaction fee $25/transaction; A maximum of six third party transactions are permitted per calendar month or statement cycle',
  '17018.disclosures.3': 'Minimum daily balance of $5,000 otherwise $12 monthly maintenance fee.',

  '17019.name': 'Certificate of Deposit (CD)',
  '17019.url': 'https://www.stbank.com/specials/',
  '17019.description.abbreviated': 'A secure way to grow your balance with a fixed interest rate and term. ',
  '17019.description': '',
  '17019.features.count': 2,
  '17019.features.1': 'Guaranteed rate for selected term',
  '17019.features.2': 'Competitive rates',
  '17019.whyBest.1.message': 'Online and Mobile banking',
  '17019.disclosures.count': 2,
  '17019.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information.',
  '17019.disclosures.2': 'Growth/Income and IRA CD Time Deposits – Annual Percentage Yield (APY) assumes interest remains on deposit until maturity, and withdrawal of interest will reduce earnings. CD Time Deposit - 1099 is produced in the year interest is paid. Penalty for early withdrawals could affect the APY and could reduce the principal for these accounts.',

  '17020.name': 'Penalty Free CD',
  '17020.url': 'https://www.stbank.com/specials/',
  '17020.description.abbreviated': 'Lock in a great rate without locking your funds away behind early withdrawal penalties.',
  '17020.description': '',
  '17020.features.count': 2,
  '17020.features.1': 'Competitive rates',
  '17020.features.2': 'Ability to withdraw funds at no cost',
  '17020.whyBest.1.message': 'Online and Mobile banking',
  '17020.disclosures.count': 2,
  '17020.disclosures.1': 'Annual Percentage Yield (APY) assumes interest remains on deposit until maturity, and withdrawal of interest will reduce earnings. No withdrawals permitted during the first 7 day period. Entire certificate may be redeemed without penalty after the first seven days. No partial withdrawals. CD will automatically renew into 12 Month Penalty Free CD with rate offered at the time of maturity. Offer may be withdrawn at any time. Minimum deposit amount is $1,000. Maximum deposit of $500,000 per household. CD Time Deposit-1099 is produced in the year interest is paid. This promotion is not available for investors and brokered accounts.',
  '17020.disclosures.2': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17021.name': 'S<span id="ampersand">&</span>T Bill CD',
  '17021.url': 'https://www.stbank.com/specials/',
  '17021.description.abbreviated': 'A 12-Month CD whose rate is tied to the 90-day Treasury Bill.',
  '17021.description': '',
  '17021.features.count': 2,
  '17021.features.1': 'Competitive rates that are adjusted monthly',
  '17021.features.2': 'Ability to deposit any time during 12-month term',
  '17021.whyBest.1.message': 'Online and Mobile banking',
  '17021.disclosures.count': 2,
  '17021.disclosures.1': 'Annual Percentage Yield (APY) assumes interest remains on deposit until maturity, and withdrawal of interest will reduce earnings. CD Time Deposit - 1099 is produced in the year interest is paid. This special cannot be combined with any other offer and excludes institutional investors, brokered accounts and money for public funds. Penalty for early withdrawals could affect the APY and could reduce principal for these accounts. This CD Time Deposit APY and interest rate cannot be combined with any other promotion. Additional deposits may be made through automatic transfers from an S<span id="ampersand">&</span>T checking or savings account. Minimum transfer amount is $50. Deposits may also be made at any branch location. Customer must have an S<span id="ampersand">&</span>T checking or savings account to open the CD. Not available on IRAs. This is a variable rate account. The APY and interest rate on the entire account balance will be adjusted and become effective the first Business Day of each month. Deposits made during the month will earn the effective rate from the date of deposit until the rate adjusts. Interest payments will only be available through transfer of funds to an S<span id="ampersand">&</span>T checking or savings account. Interest will be compounded and credited quarterly on March 31, June 30, September 30 and December 31. If withdrawals are made to this account prior to maturity date, a penalty of 90 days simple interest will be imposed. The rate of interest is tied to the 91-Day Treasury Bill rate (Discount rate in effect for the last Treasury Bill auction of the previous month).',
  '17021.disclosures.2': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17022.name': 'Mortgage',
  '17022.url': 'https://www.stbank.com/personal/borrow/mortgage/',
  '17022.description.abbreviated': 'From conventional to construction loans, prepare for your next home with a loan that fits your needs.',
  '17022.description': '',
  '17022.features.count': 3,
  '17022.features.1': 'Flexible, structured payments',
  '17022.features.2': 'Low down payment',
  '17022.features.3': 'Variety of terms to choose from',
  '17022.whyBest.1.message': 'Online and Mobile banking',
  '17022.whyBest.2.message': 'Online or paper statements',
  '17022.disclosures.count': 1,
  '17022.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17023.name': 'Veteran or Active Military Mortgage',
  '17023.url': 'https://www.stbank.com/personal/borrow/mortgage/',
  '17023.description.abbreviated': 'Home loans designed for veterans, service members and eligible surviving spouses.',
  '17023.description': '',
  '17023.features.count': 3,
  '17023.features.1': 'Flexible, structured payments',
  '17023.features.2': 'Low down payment',
  '17023.features.3': 'No private mortgage insurance requirement',
  '17023.whyBest.1.message': 'Online and Mobile banking',
  '17023.whyBest.2.message': 'Online or paper statements',
  '17023.disclosures.count': 1,
  '17023.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17024.name': 'Mortgage Refinance',
  '17024.url': 'https://www.stbank.com/personal/borrow/mortgage/',
  '17024.description.abbreviated': 'Refinance on your own terms with flexible, structured payments and a low initial deposit.',
  '17024.description': '',
  '17024.features.count': 3,
  '17024.features.1': 'Flexible, structured payments',
  '17024.features.2': 'Low down payment',
  '17024.features.3': 'Variety of terms to choose from',
  '17024.whyBest.1.message': 'Online and Mobile banking',
  '17024.whyBest.2.message': 'Online or paper statements',
  '17024.disclosures.count': 1,
  '17024.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17025.name': 'Veteran or Active Military Mortgage Refinance',
  '17025.url': 'https://www.stbank.com/',
  '17025.description.abbreviated': 'Flexible home refinancing for veterans, service members and eligible surviving spouses.',
  '17025.description': '',
  '17025.features.count': 2,
  '17025.features.1': 'Flexible, structured payments',
  '17025.features.2': 'Low down payment',
  '17025.whyBest.1.message': 'Online and Mobile banking',
  '17025.whyBest.2.message': 'Online or paper statements',
  '17025.disclosures.count': 1,
  '17025.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17026.name': 'First-time home buyer Mortgage',
  '17026.url': 'https://www.stbank.com/personal/borrow/mortgage/',
  '17026.description.abbreviated': 'Make the dream of owning your home a reality with this flexible mortgage.',
  '17026.description': '',
  '17026.features.count': 4,
  '17026.features.1': 'Flexible, structured payments',
  '17026.features.2': 'Low down payment',
  '17026.features.3': 'Variety of terms to choose from',
  '17026.features.4': 'Minimum contribution from the borrower’s own funds',
  '17026.whyBest.1.message': 'Online and Mobile banking',
  '17026.whyBest.2.message': 'Online or paper statements',
  '17026.disclosures.count': 1,
  '17026.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17027.name': 'S<span id="ampersand">&</span>T Total Line of Credit',
  '17027.url': 'https://www.stbank.com/',
  '17027.description.abbreviated': 'Use the equity in your home to fund a major purchase or home improvement.',
  '17027.description': '',
  '17027.features.count': 2,
  '17027.features.1': 'Accepted everywhere for purchases ranging from vacations to college tuition to car payments',
  '17027.features.2': 'Our convenient rate lock feature allows you to lock in all or a portion of your outstanding balance at a fixed rate and fixed term. You can lock up to 3 fixed portions at a time. As you make payments on your locked portion, it becomes available again on your line.',
  '17027.features.3': 'Option to use your line of credit as overdraft protection for your S<span id="ampersand">&</span>T checking account.',
  '17027.whyBest.1.message': 'Online and Mobile banking',
  '17027.whyBest.2.message': 'Online or paper statements',
  '17027.disclosures.count': 1,
  '17027.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17028.name': 'Home Equity Loan',
  '17028.url': 'https://www.stbank.compersonal/borrow/loans/home-equity/',
  '17028.description.abbreviated': 'Benefit from fixed, predictable monthly payments when you tap into your home’s equity.',
  '17028.description': '',
  '17028.features.count': 3,
  '17028.features.1': 'Enjoy the stability of a fixed rate and a fixed term',
  '17028.features.2': 'Enables homeowners to use the equity in their homes to secure funds for everything from home improvement to education expense to vacation',
  '17028.features.3': 'Loan proceed funds are disbursed all at once',
  '17028.whyBest.1.message': 'Online and Mobile banking',
  '17028.whyBest.2.message': 'Online or paper statements',
  '17028.disclosures.count': 1,
  '17028.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17029.name': 'Unsecured Line of Credit',
  '17029.url': 'https://www.stbank.com/personal/borrow/loans/personal',
  '17029.description.abbreviated': 'When unexpected purchases pop up, borrow what you need and only pay interest on the outstanding balance.',
  '17029.description': '',
  '17029.features.count': 2,
  '17029.features.1': 'Convenient way to pay for purchases with check writing ability',
  '17029.features.2': 'Ability to transfer funds to your checking account',
  '17029.whyBest.1.message': 'Online and Mobile banking',
  '17029.whyBest.2.message': 'Online or paper statements',
  '17029.disclosures.count': 1,
  '17029.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17030.name': 'Unsecured Personal Loan',
  '17030.url': 'https://www.stbank.com/personal/borrow/loans/personal ',
  '17030.description.abbreviated': 'Fixed, predictable payments ensure easy budgeting, perfect for a one-time borrowing need.',
  '17030.description': '',
  '17030.features.count': 2,
  '17030.features.1': 'Enjoy the stability of a fixed rate and a fixed term',
  '17030.features.2': 'Loan proceed funds are disbursed all at once',
  '17030.whyBest.1.message': 'Online and Mobile banking',
  '17030.whyBest.2.message': 'Online or paper statements',
  '17030.disclosures.count': 1,
  '17030.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17031.name': 'Auto Loan',
  '17031.url': 'https://www.stbank.com/personal/borrow/loans/auto/',
  '17031.description.abbreviated': 'Stay within your monthly budget when you finance a car with fixed-rate payments.',
  '17031.description': '',
  '17031.features.count': 3,
  '17031.features.1': 'Fixed monthly payments for easy budgeting',
  '17031.features.2': 'Competitive interest rates',
  '17031.features.3': 'Flexible terms available',
  '17031.whyBest.1.message': 'Online and Mobile banking',
  '17031.whyBest.2.message': 'Online or paper statements',
  '17031.disclosures.count': 1,
  '17031.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17032.name': 'Motorcycle Loan',
  '17032.url': 'https://www.stbank.com/',
  '17032.description.abbreviated': 'Finance a motorcycle with this fixed rate and monthly payments.',
  '17032.description': '',
  '17032.features.count': 3,
  '17032.features.1': 'Competitive interest rates',
  '17032.features.2': 'Flexible terms available',
  '17032.features.3': 'Fixed monthly payments for easy budgeting',
  '17032.whyBest.1.message': 'Online and Mobile banking',
  '17032.whyBest.2.message': 'Online or paper statements',
  '17032.disclosures.count': 1,
  '17032.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17033.name': 'Recreational Vehicle Loan',
  '17033.url': 'https://www.stbank.com/',
  '17033.description.abbreviated': 'Looking to buy an RV? Benefit from fixed monthly payments.',
  '17033.description': '',
  '17033.features.count': 3,
  '17033.features.1': 'Competitive interest rates',
  '17033.features.2': 'Fixed monthly payments for easy budgeting',
  '17033.features.3': 'Flexible terms available',
  '17033.whyBest.1.message': 'Online and Mobile banking',
  '17033.whyBest.2.message': 'Online or paper statements',
  '17033.disclosures.count': 1,
  '17033.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17034.name': 'Auto Loan Refinance',
  '17034.url': 'https://www.stbank.com/',
  '17034.description.abbreviated': 'Adjust your rate, term or monthly payment when you refinance your car loan.',
  '17034.description': '',
  '17034.features.count': 3,
  '17034.features.1': 'Fixed monthly payments for easy budgeting',
  '17034.features.2': 'Competitive interest rates',
  '17034.features.3': 'Flexible terms available',
  '17034.whyBest.1.message': 'Online and Mobile banking',
  '17034.whyBest.2.message': 'Online or paper statements',
  '17034.disclosures.count': 1,
  '17034.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17035.name': 'Motorcycle Loan Refinance',
  '17035.url': 'https://www.stbank.com/',
  '17035.description.abbreviated': 'Adjust your rate, term or monthly payment when you refinance your motorcycle loan.',
  '17035.description': '',
  '17035.features.count': 3,
  '17035.features.1': 'Fixed monthly payments for easy budgeting',
  '17035.features.2': 'Competitive interest rates',
  '17035.features.3': 'Flexible terms available',
  '17035.whyBest.1.message': 'Online and Mobile banking',
  '17035.whyBest.2.message': 'Online or paper statements',
  '17035.disclosures.count': 1,
  '17035.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17036.name': 'Recreational Vehicle Loan Refinance',
  '17036.url': 'https://www.stbank.com/',
  '17036.description.abbreviated': 'Adjust your rate, term or monthly payment when you refinance your RV loan.',
  '17036.description': '',
  '17036.features.count': 3,
  '17036.features.1': 'Fixed monthly payments for easy budgeting',
  '17036.features.2': 'Competitive interest rates',
  '17036.features.3': 'Flexible terms available',
  '17036.whyBest.1.message': 'Online and Mobile banking',
  '17036.whyBest.2.message': 'Online or paper statements',
  '17036.disclosures.count': 1,
  '17036.disclosures.1': 'Mobile Banking is offered as a free service of S<span id="ampersand">&</span>T Bank. You may incur and are responsible for any charges assessed by your mobile carrier. Contact your mobile carrier for more information',

  '17037.name': 'Visa® Platinum',
  '17037.url': 'https://secure-web.cisco.com/1RoEVjGsl3HkHAUZM29o9fyqGFR3tiLNnBPz5cHfpBhVhesWHmF5USKwlhEQ27BZ-IJSPmLnPbRnqp_H979QUn_e5Hwl7atl3Z0i6SHXGVh-LxOcIcM78p1Et-HQiLRAxso0MkkjgxoRD7w0VPfKboWjNUjmCxARapVIIdadwS5uUAwl_Vp79hV9EIAkIf0A5crxPnXbw4ODgZJ2K7CPpO4soa1Aoy7gWZjqHlSMzrvU-QuvcnEL01J2e-_hK-z_GBMGXShKZIAZ9RCmgCs-NApUyic8jq9EBDkyg9ENC29OXCpy8TtCJqsJ0ipme72wrp1EKYr_6AIEIp6lgZJ8Muph5kfHg3b-BsgBOnlFR1jgteCgWiIzJek0vkmjma6BkwQHw5nQzquOCe4IPDrv0XQ/https%3A%2F%2Fcreditcardlearnmore.com%2F11t3%2Findex%3Fecdma-lc%3D24710%26ecid%3DOTHE_25940',
  '17037.description.abbreviated': 'Pay down your other credit card balances faster with this unique introductory offer.',
  '17037.description': '',
  '17037.features.count': 4,
  '17037.features.1': 'Pay down your other credit card balances faster with a great low introductory rate for an extended time',
  '17037.features.2': 'Save on interest ',
  '17037.features.3': 'Non-rewards',
  '17037.features.4': 'EMV smart chip technology for added security ',
  '17037.disclosures.count': 0,

  '17038.name': 'Visa® Everyday Rewards+ Card',
  '17038.url': 'https://secure-web.cisco.com/1RoEVjGsl3HkHAUZM29o9fyqGFR3tiLNnBPz5cHfpBhVhesWHmF5USKwlhEQ27BZ-IJSPmLnPbRnqp_H979QUn_e5Hwl7atl3Z0i6SHXGVh-LxOcIcM78p1Et-HQiLRAxso0MkkjgxoRD7w0VPfKboWjNUjmCxARapVIIdadwS5uUAwl_Vp79hV9EIAkIf0A5crxPnXbw4ODgZJ2K7CPpO4soa1Aoy7gWZjqHlSMzrvU-QuvcnEL01J2e-_hK-z_GBMGXShKZIAZ9RCmgCs-NApUyic8jq9EBDkyg9ENC29OXCpy8TtCJqsJ0ipme72wrp1EKYr_6AIEIp6lgZJ8Muph5kfHg3b-BsgBOnlFR1jgteCgWiIzJek0vkmjma6BkwQHw5nQzquOCe4IPDrv0XQ/https%3A%2F%2Fcreditcardlearnmore.com%2F11t3%2Findex%3Fecdma-lc%3D24710%26ecid%3DOTHE_25940',
  '17038.description.abbreviated': 'Earn points for every dollar you spend on eligible purchases.',
  '17038.description': '',
  '17038.features.count': 5,
  '17038.features.1': '4x unlimited points on dining, take-out & food delivery.¹',
  '17038.features.2': '2X unlimited points at grocery stores, grocery delivery, gas stations and streaming services.',
  '17038.features.3': '1x unlimited points on all other eligible purchases.',
  '17038.features.4': '$150 bonus reward (15,000 points) after you spend $500 within first 90 days of account opening.²',
  '17038.features.5': 'Redeem points for Travel, Cash Back and More.',
  '17038.disclosures.count': 2,
  '17038.disclosures.1': 'Everyday Rewards+ Card: You will earn 1 Point for every dollar in eligible net purchases charged to your Account during each billing cycle. In addition, you will earn additional Points for the following: You will earn 3 additional Points for every dollar in eligible net purchases during each billing cycle at merchants classified as a restaurant, fast-food restaurant or bar. You will earn 1 additional Point for every dollar in eligible net purchases during each billing cycle at merchants classified as gas station, grocery store, supermarket or qualifying streaming subscription service. Refer to program rules for official list of qualifying streaming services merchants. Purchases at or delivery from discount/retail stores that sell groceries may not qualify for the grocery store or grocery delivery category. Purchases qualify for Points based on how merchants choose to classify their business and we reserve the right to determine which purchases qualify. Reward points can be redeemed as a cash deposit to a checking or savings account with this Financial Institution only, which will be deposited within seven business days, or as a statement credit to your credit card account, which will be deposited within one to two billing cycles or as a Rewards Card ($25 minimum redemption). Points expire five years from the end of the quarter in which they are earned. ',
  '17038.disclosures.2': 'If you’re approved for a new Everyday Rewards+ Card, a one-time 15,000 bonus points ($150 value) will be awarded after eligible net purchases totaling $500 or more are made to your account within 90 days from account opening. Please allow 6-8 weeks after you have met the spend requirement for your bonus to be credited to your rewards balance.',

  '17039.name': 'Visa® College Real Rewards',
  '17039.url': 'https://secure-web.cisco.com/1RoEVjGsl3HkHAUZM29o9fyqGFR3tiLNnBPz5cHfpBhVhesWHmF5USKwlhEQ27BZ-IJSPmLnPbRnqp_H979QUn_e5Hwl7atl3Z0i6SHXGVh-LxOcIcM78p1Et-HQiLRAxso0MkkjgxoRD7w0VPfKboWjNUjmCxARapVIIdadwS5uUAwl_Vp79hV9EIAkIf0A5crxPnXbw4ODgZJ2K7CPpO4soa1Aoy7gWZjqHlSMzrvU-QuvcnEL01J2e-_hK-z_GBMGXShKZIAZ9RCmgCs-NApUyic8jq9EBDkyg9ENC29OXCpy8TtCJqsJ0ipme72wrp1EKYr_6AIEIp6lgZJ8Muph5kfHg3b-BsgBOnlFR1jgteCgWiIzJek0vkmjma6BkwQHw5nQzquOCe4IPDrv0XQ/https%3A%2F%2Fcreditcardlearnmore.com%2F11t3%2Findex%3Fecdma-lc%3D24710%26ecid%3DOTHE_25940',
  '17039.description.abbreviated': 'This card is designed for college students as a way to build credit.',
  '17039.description': '',
  '17039.features.count': 4,
  '17039.features.1': 'Earn 1.5 points monthly for every $1 you spend on eligible net purchases (equal to 1.5% cash back)<sup>1, 3</sup>',
  '17039.features.2': 'No caps or limits on the number of points you can earn, and you have five years to redeem for rewards<sup>1</sup>',
  '17039.features.3': '2,500 bonus rewards points awarded after first purchase<sup>2</sup>',
  '17039.features.4': 'EMV smart chip technology for added security',
  '17039.disclosures.count': 3,
  '17039.disclosures.1': 'The Elan Rewards Program is subject to change. Rewards are earned on eligible net purchases. Net purchases are purchases minus credits and returns. Not all transactions are eligible to earn rewards, such as Advances, Balance Transfers and Convenience Checks. Upon approval, see your Card Member Agreement for details. You may not redeem Points, and you will immediately lose all of your Points, if your Account is closed to future transactions (including, but not limited to, due to Program misuse, failure to pay, bankruptcy, or death).',
  '17039.disclosures.2': 'First purchase bonus points will be applied 6 to 8 weeks after first purchase and are not awarded for balance transfers or cash advances. Please allow 6-8 weeks after you have met the spend requirement for your bonus points to be credited to your account.',
  '17039.disclosures.3': 'Real Rewards: You will earn 1.5 Reward Points ("Points") for each dollar of eligible Net Purchases made with your Account within a billing cycle (equal to 1.5% cash back). Monthly net purchase points will be applied each billing cycle. Points expire five years from the end of the quarter in which they are earned.',

  '17040.name': 'Cash Rewards American Express',
  '17040.url': 'https://www.stbank.com/personal/borrow/credit-cards/',
  '17040.description.abbreviated': 'Get cash rewards on gas and groceries with a 1% cash back on other eligible purchases.',
  '17040.description': '',
  '17040.features.count': 3,
  '17040.features.1': 'EMV smart chip technology for added security',
  '17040.features.2': 'Cash back on eligible purchases',
  '17040.features.3': '$25 cash back awarded after first purchase',
  '17040.disclosures.count': 4,
  '17040.disclosures.1': 'Reward points can be redeemed as a cash deposit to a checking or savings account with S<span id="ampersand">&</span>T Bank or as a statement credit to your credit card account within one to two billing cycles.',
  '17040.disclosures.2': 'Cash Rewards Card: "Cash Back Rewards" are the rewards you earn under the program. Cash Back Rewards are tracked as points and each point in Cash Back Rewards earned is equal to $0.01. You may simply see "Cash Back" in marketing material when referring to the rewards you earn. You will earn 1 Reward Point ("Point") for each dollar of eligible Net Purchases charged to your Account during each billing cycle. You will also earn 1 additional Point (for a total of 2 Points) for each dollar of eligible Net Purchases charged to your Account during each billing cycle for any merchant classified as a supermarket. The number of additional Points earned on supermarket Purchases is unlimited. In addition, you will earn 2 additional Points (for a total of 3 Points) for each dollar of Net Purchases charged to your Account during each billing cycle at merchant locations that are classified in any of the following merchant categories codes: automated fuel dispensers and service stations, up to a maximum of $6,000 spent during each 12-month period commencing on the anniversary date of this Account. Automated fuel dispenser and service station purchases above $6,000 (for the remainder of that 12 month period) will earn at a rate of 1 Point for each dollar of Net Purchases charged to your Account during each billing cycle. Points expire five years from the end of the quarter in which they are earned.',
  '17040.disclosures.3': 'First purchase bonus points will be applied 6 to 8 weeks after first purchase and are not awarded for balance transfers or cash advances. Please allow 6-8 weeks after you have met the spend requirement for your bonus points to be credited to your account.',
  '17040.disclosures.4': 'The Elan Rewards Program is subject to change. Rewards are earned on eligible net purchases. Net purchases are purchases minus credits and returns. Not all transactions are eligible to earn rewards, such as Advances, Balance Transfers and Convenience Checks. Upon approval, see your Card Member Agreement for details. You may not redeem Points, and you will immediately lose all of your Points, if your Account is closed to future transactions (including, but not limited to, due to Program misuse, failure to pay, bankruptcy, or death).',

  '17041.name': 'Premier Rewards American Express',
  '17041.url': 'https://www.stbank.com/personal/borrow/credit-cards/',
  '17041.description.abbreviated': 'Earn points on travel with cash back, gift cards or name brand merchandise.',
  '17041.description': '',
  '17041.features.count': 5,
  '17041.features.1': 'EMV smart chip technology for added security',
  '17041.features.2': 'Annual fee is waived for the first year',
  '17041.features.3': 'Perks for those that travel frequently',
  '17041.features.4': 'No caps or limits on the number of points you can earn, and you have five years to redeem for rewards',
  '17041.features.5': 'No foreign transaction fees',
  '17041.disclosures.count': 0,
  '17041.disclosures.1': 'The Elan Rewards Program is subject to change. Rewards are earned on eligible net purchases. Net purchases are purchases minus credits and returns. Not all transactions are eligible to earn rewards, such as Advances, Balance Transfers and Convenience Checks. Upon approval, see your Card Member Agreement for details. You may not redeem Points, and you will immediately lose all of your Points, if your Account is closed to future transactions (including, but not limited to, due to Program misuse, failure to pay, bankruptcy, or death).',
  '17041.disclosures.2': 'Premier Rewards Card Points: You will earn 1 Reward Point ("Point") for each dollar of eligible Net Purchases charged to your Account during each billing cycle. You will also earn 1 additional Point (for a total of 2 Points) for each dollar of Net Purchases charged to your Account during each billing cycle at merchants which categorize their business as a service station or automated fuel dispensers. You will earn 2 additional Points (for a total of 3 Points) for each dollar of Net Purchases charged to your Account during each billing cycle at merchant locations that are classified in the merchant category code of airlines. You will earn 3 additional Points (for a total of 4 Points) for each dollar of Net Purchases charged to your Account during each billing cycle at any merchant classified as a restaurant. Points expire five years from the end of the quarter in which they are earned.',
  '17041.disclosures.3': 'Certain limitations and restrictions may apply. Further details are available in the Guide to Benefits which is provided to new card members upon approval. The creditor and issuer of these cards is Elan Financial Services, pursuant to separate licenses from Visa U.S.A Inc. and American Express. American Express is a federally registered service mark of American Express.',

  '17042.name': 'Visa® Secured',
  '17042.url': 'https://secure-web.cisco.com/1RoEVjGsl3HkHAUZM29o9fyqGFR3tiLNnBPz5cHfpBhVhesWHmF5USKwlhEQ27BZ-IJSPmLnPbRnqp_H979QUn_e5Hwl7atl3Z0i6SHXGVh-LxOcIcM78p1Et-HQiLRAxso0MkkjgxoRD7w0VPfKboWjNUjmCxARapVIIdadwS5uUAwl_Vp79hV9EIAkIf0A5crxPnXbw4ODgZJ2K7CPpO4soa1Aoy7gWZjqHlSMzrvU-QuvcnEL01J2e-_hK-z_GBMGXShKZIAZ9RCmgCs-NApUyic8jq9EBDkyg9ENC29OXCpy8TtCJqsJ0ipme72wrp1EKYr_6AIEIp6lgZJ8Muph5kfHg3b-BsgBOnlFR1jgteCgWiIzJek0vkmjma6BkwQHw5nQzquOCe4IPDrv0XQ/https%3A%2F%2Fcreditcardlearnmore.com%2F11t3%2Findex%3Fecdma-lc%3D24710%26ecid%3DOTHE_25940',
  '17042.description.abbreviated': 'Build or rebuild your credit history with flexible credit lines based on a security deposit.',
  '17042.description': '',
  '17042.features.count': 2,
  '17042.features.1':'Provides an excellent opportunity for someone starting a credit history or for someone who has been turned down for a credit card. If you need to establish or re-establish your credit history,<sup>1</sup> here is a great way to begin that process',
  '17042.features.2': 'EMV smart chip technology for added security',
  '17042.disclosures.count': 1,
  '17042.disclosures.1': 'Late payments and going over the credit limit may damage your credit history.',

  '17043.name': 'Visa® Max Cash Preferred',
  '17043.url': 'https://secure-web.cisco.com/1RoEVjGsl3HkHAUZM29o9fyqGFR3tiLNnBPz5cHfpBhVhesWHmF5USKwlhEQ27BZ-IJSPmLnPbRnqp_H979QUn_e5Hwl7atl3Z0i6SHXGVh-LxOcIcM78p1Et-HQiLRAxso0MkkjgxoRD7w0VPfKboWjNUjmCxARapVIIdadwS5uUAwl_Vp79hV9EIAkIf0A5crxPnXbw4ODgZJ2K7CPpO4soa1Aoy7gWZjqHlSMzrvU-QuvcnEL01J2e-_hK-z_GBMGXShKZIAZ9RCmgCs-NApUyic8jq9EBDkyg9ENC29OXCpy8TtCJqsJ0ipme72wrp1EKYr_6AIEIp6lgZJ8Muph5kfHg3b-BsgBOnlFR1jgteCgWiIzJek0vkmjma6BkwQHw5nQzquOCe4IPDrv0XQ/https%3A%2F%2Fcreditcardlearnmore.com%2F11t3%2Findex%3Fecdma-lc%3D24710%26ecid%3DOTHE_25940',
  '17043.description.abbreviated': 'Cash back maximized to fit your life.',
  '17043.description': '',
  '17043.features.count': 5,
  '17043.features.1': '5% cash back on first $2,000 of combined quarterly purchases in two categories like:  TV, Internet & Streaming Services, Home Utilities, Cell Phone Providers and more!<sup>1</sup>',
  '17043.features.2': '2% unlimited cash back on choice of one everyday category like Gas Stations & Ground Transportation, Restaurants & Food Delivery and Grocery Stores and Grocery Delivery.',
  '17043.features.3': '1% unlimited cash back on all other eligible purchases.',
  '17043.features.4': 'Redeem Cash Back for a Statement Credit, Rewards Card, or a Deposit to a Qualifying Account.<sup>1</sup>',
  '17043.features.5': '$150 cash back after you spend $500 in the first 90 days.<sup>2</sup>',
  '17043.disclosures.count': 2,
  '17043.disclosures.1': 'Max Cash Preferred Card: Cardmember must initially enroll into categories of their choice, or all net purchases will earn no more than 1% cash back. Categories are subject to change. You will earn 5% cash back on your first $2,000 in combined net purchases each calendar quarter in your two chosen 5% categories and unlimited cash back in your 2% category. All other net purchases earn 1% cash back. Transactions qualify for 5% or 2% cash back based on how merchants classify the transaction. Upon approval, full details will be provided in your Cardmember Agreement. Cash rewards can be redeemed as a deposit to a checking or savings account with this Financial Institution only, which will be deposited within seven business days, or as a statement credit to your credit card account, which will be deposited within one to two billing cycles or as a Rewards Card ($25 minimum redemption). Cash rewards do not expire as long as the account remains active. If there is no reward, purchase, or balance activity on your account for 12 statement cycles, your cash rewards balance will expire.',
  '17043.disclosures.2': 'If you’re approved for a new Max Cash Preferred Card, one-time $150 bonus will be awarded for redemption after eligible net purchases totaling $500 or more are made to your account within 90 days from account opening. Please allow 6-8 weeks after you have met the spend requirement for your bonus to be credited to your rewards balance.',

  //Deprecated Keys
  'reasonForVisit.find': 'Finding a bank who cares about my financial needs',
  'reasonForVisit.find.subtext': 'Financial Care',
  'reasonForVisit.understand': "Help understanding the right financial solutions",
  'reasonForVisit.understand.subtext': 'Solutions',
  'reasonForVisit.funds': 'I need additional funds to help accomplish my goal(s)',
  'reasonForVisit.funds.subtext': 'Funds',
  'reasonForVisit.location': 'S<span id="ampersand">&</span>T branch locations are convenient',
  'reasonForVisit.location.subtext': 'Convenience',
  'reasonForVisit.digital': "I'm looking to do more of my banking digitally",
  'reasonForVisit.digital.subtext': 'Digital Banking',
  'reasonForVisit.advice': 'A bank who listens to provide financial advice',
  'reasonForVisit.advice.subtext': 'Advice',
};